{
  "LIST_FILTER_ROW": {
  	"aria_label": "Filter",
  	"status": "Status",
  	"open_amount": "offener Saldo",
  	"more": "+{{count}} weitere",
  	"search_tag": "Tag suchen…",
  	"or_hint": "eines dieser Tags",
  	"clear_all": "alles löschen",
  	"clear_filters": "Filter löschen",
  	"no_results_filters": "keine Buchungen mit diesen Filtern.",
  	"clear_chip": "{{name}} löschen",
  	"bookings_total": "{{count}} Buchungen",
  	"bookings_total_one": "{{count}} Buchung",
  	"flights_total": "{{count}} Fahrten",
  	"flights_total_one": "{{count}} Fahrt",
  	"search_hint": "Enter zum Suchen · Datum = jjjj-mm-tt",
  	"more_actions": "weitere Aktionen",
  	"period": "Zeitraum",
  	"period_all": "alle",
  	"period_today": "heute",
  	"period_this_week": "diese Woche",
  	"period_this_month": "dieser Monat",
  	"period_next_month": "nächster Monat",
  	"period_custom": "benutzerdefiniert…",
  	"free_spots": "freie Plätze",
  	"free_spots_all": "alle",
  	"free_spots_min": "mindestens {{n}}",
  	"free_spots_overbooked": "überbucht"
  },
  "SEARCH_ELSEWHERE": {
    "none_in_filter": "keine Treffer in „{{filter}}“ für „{{search}}“.",
    "found_in": "gefunden in:",
    "also_found_in": "auch gefunden in"
  },
  "LOGIN": {
    "email_me_a_login_link": "senden Sie mir einen Anmeldelink",
    "login_link_sent": "ein Anmeldelink wurde gesendet",
    "signed_in_elsewhere_title": "Sie sind angemeldet",
    "signed_in_elsewhere": "Sie sind über den Link in einem anderen Tab angemeldet — Sie können diesen Tab schließen",
    "continue_here": "hier fortfahren",
    "completing_signin": "Sie werden angemeldet…",
    "confirm_email_for_link": "bitte bestätigen Sie Ihre E-Mail-Adresse, um die Anmeldung abzuschließen",
    "continue": "weiter",
    "login_link_invalid": "dieser Anmeldelink ist nicht mehr gültig. Bitte fordern Sie einen neuen an.",
    "request_new_link": "neuen Link anfordern"
  },
  "MONTY": {
      "requested_prefix": "Kunde fragt",
      "requested_MATCH": "{{date}} → Fahrt {{flight}} ({{free}} frei)",
      "requested_CURRENT": "{{date}} → bereits auf dieser Fahrt ({{flight}})",
      "requested_FULL": "{{date}} → ausgebucht in der Zone",
      "requested_NOT_PLANNED": "{{date}} → noch keine Fahrt in der Zone geplant",
      "requested_PRIVATE_ONLY": "{{date}} → nur eine private Fahrt ({{flight}})",
      "requested_OUT_OF_VALIDITY": "{{date}} → nach der Gültigkeit der Buchung",
      "requested_PAST": "{{date}} → in der Vergangenheit",
      "date_conflict": "Wochentag und Datum passten nicht zusammen, das Datum wurde verwendet",
      "needs_review": "Text prüfen: {{items}} stammt nicht aus den Fahrtdaten",
      "tag_P": "Planung",
      "tag_Q": "Frage",
      "tag_W": "Wetter",
      "tag_C": "Beschwerde / sensibel",
      "tag_N": "keine Aktion nötig",
      "action_accepted_line": "Aktion über Monty ausgeführt",
    "accept": "übernehmen",
      "dismiss": "Aktion ablehnen",
      "action_repick": "klicken, um eine andere Fahrt zu wählen",
      "action_CONFIRM_ON_FLIGHT": "Buchung bestätigen auf",
      "action_MOVE_TO_FLIGHT": "Buchung verschieben nach",
      "action_REMOVE_FROM_FLIGHT": "Buchung entfernen von",
      "failure_FLIGHT_FULL": "Fahrt ist voll oder geschlossen — andere Fahrt wählen",
      "failure_FLIGHT_CANCELLED": "Fahrt wurde abgesagt — andere Fahrt wählen",
      "failure_PROPOSAL_NOT_OPEN": "Vorschlag ist nicht mehr offen",
      "proposal_strip": "Vorschlag von Monty — anpassen oder senden",
      "proposal_clear": "Vorschlag entfernen",
      "proposal_insert": "Vorschlag verfügbar — klicken zum Einfügen",
      "settings_panel_title": "Monty - dein KI-Assistent",
      "settings_key_title": "Anthropic-API-Schlüssel",
      "settings_key_note": "Monty läuft über dein eigenes Anthropic-Konto: gib deinen API-Schlüssel ein, um zu aktivieren. Die Kosten laufen über dein Konto.",
      "settings_key_label": "API-Schlüssel",
      "settings_key_save": "speichern & prüfen",
      "settings_key_replace": "ändern",
      "settings_key_remove": "entfernen",
      "status_active": "aktiv",
      "status_no_credits": "kein Guthaben mehr — Monty ist pausiert",
      "status_no_credits_note": "neue Nachrichten erhalten vorerst kein Label; Monty macht automatisch weiter, sobald wieder Guthaben da ist",
      "status_key_invalid": "Schlüssel ungültig — Monty ist inaktiv",
      "status_off": "nicht konfiguriert",
      "settings_usage_title": "Verbrauch & Kosten",
      "settings_usage_note": "Schätzung auf Basis des Tokenverbrauchs und der Listenpreise; Abrechnung über dein eigenes Anthropic-Konto",
      "usage_month": "Monat",
      "usage_classifications": "Klassifizierungen",
      "usage_proposals": "Vorschläge",
      "usage_cost": "geschätzte Kosten",
      "usage_learn_runs": "Lernläufe",
      "instructions_title": "Anweisungen pro Kategorie",
      "instructions_note": "beschreibe, wie du jede Art von Nachricht üblicherweise beantwortest (Ton, Standardinfos, Regeln) — Monty berücksichtigt dies beim Entwerfen von Antworten",
      "instructions_manual_label": "deine Anweisungen",
      "instructions_learned_title": "Vorschlag aus dem Verlauf — prüfen und anpassen",
      "instructions_learned_from": "basierend auf {{count}} beantworteten Nachrichten der letzten {{months}} Monate",
      "instructions_learned_note": "Monty verwendet diesen Vorschlag bereits zusammen mit deinen eigenen Anweisungen. Übernimm ihn in deine Anweisungen, um ihn dauerhaft zu machen — sonst ersetzt ihn der nächste Lernlauf.",
      "instructions_adopt_draft": "in meine Anweisungen übernehmen",
      "instructions_discard_draft": "Vorschlag verwerfen",
      "instructions_save": "speichern",
      "learn_title": "aus dem Verlauf lernen",
      "learn_note": "Monty taggt deine bisherigen Unterhaltungen und destilliert pro Kategorie, wie du üblicherweise antwortest; das Ergebnis erscheint oben als bearbeitbarer Vorschlag",
      "learn_button": "aus dem Verlauf lernen",
      "learn_month": "Monat",
      "learn_months": "Monate",
      "learn_messages": "Nachrichten",
      "learn_estimated_cost": "geschätzte Kosten",
      "learn_warning": "dieser Lauf verbraucht das Guthaben deines eigenen Anthropic-Kontos",
      "learn_start": "Lernlauf starten",
      "learn_cancel_dialog": "abbrechen",
      "learn_no_messages": "keine Nachrichten in diesem Zeitraum",
      "learn_progress": "{{done}} von {{total}} Nachrichten verarbeitet",
      "learn_phase_TAGGING": "Verlauf wird getaggt",
      "learn_phase_DISTILLING": "Anweisungen werden destilliert",
      "learn_state_RUNNING": "Lernlauf läuft",
      "learn_state_COMPLETED": "Lernlauf abgeschlossen",
      "learn_state_CANCELLED": "Lernlauf abgebrochen",
      "learn_state_STOPPED_NO_CREDITS": "gestoppt — kein Guthaben mehr; bereits gesetzte Tags bleiben erhalten",
      "learn_resume": "fortsetzen",
      "learn_cancel_run": "Lauf abbrechen",
      "learn_cost_so_far": "verbraucht"
  },
  "CHARTS": {
    "last1months": "1 m",
    "last3months": "3 m",
    "last6months": "6 m",
    "last12months": "12 m",
    "last24months": "24 m"
  },
  "VALIDATIONS": {
    "checkin_edit": "bearbeiten",
    "checkin_clear_signoff": "Unterschrift löschen",
    "checkin_clear_signoff_confirm": "Unterschrift des Piloten löschen? Der Flug gilt als nicht unterschrieben, bis erneut unterschrieben wird.",
    "checkin_manual_value": "vom Piloten beim Check-in manuell gesetzt",
    "checkin_signed_off": "der Flug ist bereits unterschrieben - zuerst die Unterschrift löschen",
    "checkin_flight_not_found": "Flug nicht gefunden",
    "checkin_invalid_hour": "ungültige Startzeit",
    "checkin_invalid_tempTakeoff": "Starttemperatur muss zwischen -40 und 50 °C liegen",
    "checkin_invalid_tempBalloon": "Ballontemperatur muss zwischen 50 und 150 °C liegen",
    "checkin_invalid_windGl": "Bodenwind muss zwischen 0 und 60 kt liegen",
    "checkin_invalid_windGlDirection": "Windrichtung muss zwischen 0 und 360° liegen",
    "checkin_invalid_weatherQnh": "QNH muss zwischen 900 und 1100 hPa liegen",
    "checkin_invalid_plannedFlightTime": "geplante Flugzeit muss positiv sein und darf die maximale Flugzeit nicht überschreiten",
    "load_failed": "diese Daten konnten nicht geladen werden",
    "error": "Ein unerwarteter Fehler ist aufgetreten, überprüfen Sie Ihre Eingabe",
    "minimun_one_adult_or_Child_is_required": "Sie benötigen mindestens einen Erwachsenen oder ein Kind",
    "error_tenant_does_not_exist": "der Betreiber existiert nicht",
    "not_possible": "diese Aktion ist nicht möglich",
    "required": "Pflichtfeld",
    "tenant_is_required": "Betreiber ist ein Pflichtfeld",
    "email_is_required": "E-Mail ist ein Pflichtfeld",
    "wrong_password": "falsches Passwort",
    "check_email": "es wurde ein Link zum Zurücksetzen des Passworts gesendet",
    "International_phone_format": "internationales Format erforderlich",
    "email": "ungültige E-Mail Adresse",
    "duplicate_email": "doppelte E-Mail-Adressen sind nicht erlaubt",
    "no_integer": "dies ist keine gültige ganze Zahl",
    "positive_number": "muss null oder positiv sein",
    "lift_orange_below_red": "die grüne Grenze muss mindestens der orangen entsprechen",
    "token_has_expired": "der Token ist abgelaufen",
    "wrong_credentials": "falsche Zugangsdaten",
    "flight_date_in_past": "dieser Flug liegt in der Vergangenheit",
    "save_or_cancel_updates": "Es wurden Änderungen vorgenommen. Bitte zuerst speichern oder abbrechen.",
    "warning": "Warnung",
    "capacity_must_be_between_0_and_30": "die Kapazität muss zwischen 0 und 100 liegen",
    "validation_errors": "Bitte zuerst die Fehler im Formular beheben",
    "mismatch_location": "der Standort liegt nicht in der Buchungsregion",
    "mismatch_availability": "das Fahrtdatum stimmt nicht mit der Buchungsverfügbarkeit überein",
    "mismatch_start_date": "das Fahrtdatum liegt vor dem Startdatum der Buchung",
    "mismatch_end_date": "das Fahrtdatum liegt nach dem Enddatum der Buchung",
    "mismatch_type": "der Fahrttyp stimmt nicht mit der Buchungsart überein",
    "mismatch_flight": "für eine andere Fahrt gebucht",
    "missing_function": "Diese Funktion steht in Kürze zur Verfügung",
    "attachment_not_found": "Datei nicht im Speicher gefunden",
    "invalid_file_only_pdf_jpg_png_max_10MB": "Ungültige Datei: nur PDF, JPG und PNG bis 10 MB werden akzeptiert.",
    "invalid_file_too_large_max_10MB": "Die Datei ist zu groß: die maximale Größe beträgt 10 MB.",
    "no_category": "keine Passagierkategorien gefunden. Gehen Sie zuerst zu den Einstellungen, um 1 oder mehrere Kategorien hinzuzufügen.",
    "no_region": "keine Region gefunden, gehen Sie zuerst zu Regionen, um 1 oder mehrere Regionen hinzuzufügen.",
    "lift_mismatch": "Die Tragkraftberechnung ist aufgrund fehlender Daten nicht möglich",
    "lift_missing_location": "Standort fehlt",
    "lift_missing_balloon_volume": "Hüllvolumen ist unbekannt",
    "lift_missing_balloon_weight": "Ballongewicht ist unbekannt oder unvollständig",
    "lift_missing_pilot": "Pilot ist unbekannt",
    "lift_missing_pilot_weight": "Gewicht des Piloten ist unbekannt",
    "lift_missing_temp_takeoff": "die Starttemperatur ist unbekannt",
    "lift_missing_pressure": "der Luftdruck am Startort ist unbekannt",
    "mobile_missing_signature": "Es wurden nicht alle Passagiere abgefertigt",
    "mobile_missing_forecast": "keine Wettervorhersage verfügbar",
    "mobile_documents": "Ablaufdaten",
    "mobile_doc_insurance": "Versicherung gültig bis",
    "mobile_doc_airworthiness": "Lufttüchtigkeit gültig bis",
    "mobile_doc_license": "Pilotenlizenz gültig bis",
    "mobile_clear": "Löschen",
    "mobile_agree": "Zustimmen",
    "mobile_self_sign": "X",
    "click_to_fly": "Angaben korrekt?",
    "click_to_fly_all": "Alles korrekt?",
    "pax_good_to_fly": "Pax ok",
    "lift_good_to_fly": "Auftrieb ok",
    "fuel_good_to_fly": "Treibstoff ok",
    "weather_good_to_fly": "Wetter ok",
    "docs_good_to_fly": "Dokumente ok",
    "pilot_sign_off": "alle Parameter bestätigen und zur Genehmigung unterschreiben. Zunächst können Kommentare zu den Parametern hinzugefügt werden.",
    "agree": "Zustimmen",
    "redo": "Rückgängig machen",
    "new_version": "neue Version verfügbar",
    "reload_the_app": "Möchten Sie Quick Release jetzt neu starten?",
    "new_features_available": "{0} neue Funktionen verfügbar",
    "show_new_features": "neue Funktionen anzeigen",
    "forget_device": "Abmelden und Gerät vergessen",
    "bookings_with_open_amount": "Buchungen mit offenem Betrag",
    "bookings_to_confirm": "zu bestätigen",
    "bookings_bookmarked": "mit Lesezeichen",
    "cylinder_capacity_must_be_between_0_and_200": "Volumen muss zwischen 0 und 200 liegen",
    "cylinder_weight_must_be_between_0_and_200": "Gewicht muss zwischen 0 und 200 liegen",
    "unauthorized": "Sie haben für diesen Vorgang keine Berechtigung",
    "disconnected": "Verbindung verloren, bitte die Internetverbindung prüfen",
    "possible_duplicates": "Wir haben eventuell eine doppelte Buchung gefunden (gleiche Kontaktdaten bei anderer offenen Buchung)",
    "possible_duplicates_with_flights": "Wir haben eventuell eine doppelte Buchung auf einer anderen Fahrt gefunden",
    "duplicate_flight": "Ballon ist schon gebucht",
    "duplicate_pilot": "Pilot ist schon gebucht",
    "crew_ready_changed_warning": "Die Crew wurde bereits benachrichtigt. Bitte informieren Sie sie über die Änderungen."
  },
  "HINTS": {
    "add_country_code": "Ländervorwahl hinzufügen (+49)",
    "no_contact_selected": "Einen Kontakt wählen",
    "message_filter": "Filter ein/aus",
    "role_can_only_be_set_after_creation": "Die Rolle kann erst nach der Erstellung festgelegt werden",
    "please_wait": "bitte warten"
  },
  "SKEYES": {
    "ballooning_bulletin": "Ballooning Bulletin",
    "load": "Skeyes login",
    "disclaimer": "Ballooning Bulleting ist ein Service von Skeyes.",
    "instructions": "Geben Sie Ihren Skeyes Login und Passwort ein, um das Ballooning Bulletin abzurufen. Nur Piloten mit einem gültigen Abonnement können das Ballooning Bulletin abrufen. Die Daten werden nur verwendet um das Ballooning Bulletin abzurufen und werden nicht gespeichert. Skeyes Nutzungsbedingungen finden Anwendung.",
    "username": "Skeyes Username",
    "password": "Skeyes Password",
    "loaded_by": "geladen von",
    "loading_can_take_up_to_15sec": "das Laden kann bis zu 15 Sekunden dauern",
    "error": "Unerwarteter Fehler, überprüfen Sie alle Felder",
    "slot_warning": "dieses Bulletin gilt möglicherweise nicht für diese Fahrt"
  },
  "APPLICATION": {
    "domain": "Domain",
    "Nl": "Nederlands (dutch)",
    "Fr": "Français (french)",
    "En": "English",
    "Es": "Español (spanish)",
    "Cs": "cesky (czech)",
    "It": "Italiano (Italian)",
    "De": "Deutsch (German)",
    "Pt": "Português (portuguese)",
    "Lv": "Latviešu (Latvian)",
    "date": "Datum",
    "name": "Name",
    "call_sign": "Kennzeichen",
    "capacity": "Kapazität",
    "flight_count": "Fahrten",
    "sku": "sku",
    "unit_count": "Einheiten",
    "unit_cost": "Stückpreis",
    "send_sms": "SMS versenden",
    "receive_sms": "Empfangene SMS",
    "sms_count": "SMS",
    "payments": "Zahlungen",
    "running_month": "laufender Monat",
    "history_balloons": "Verlauf Ballone",
    "history_sms": "Verlauf SMS",
    "total_cost": "Preis",
    "sorry": "Entschuldigung",
    "flights": "Fahrten",
    "calendar": "Kalender",
    "vouchers": "Voucher",
    "bookings": "Buchungen",
    "balloons": "Ballone",
    "crew": "Crew und Piloten",
    "regions": "Regionen",
    "locations": "Standorte",
    "reports": "Berichte",
    "logbooks": "Flugbücher",
    "admin": "Admin",
    "releasenotes": "release notes",
    "subscription": "Abonnement",
    "log_sms_in": "eingehende SMS",
    "log_sms_out": "ausgehende SMS",
    "settings": "Einstellungen",
    "cylinders": "Zylinder",
    "language": "Sprache",
    "sms": "SMS",
    "help": "Hilfe",
    "search": "Suche",
    "live_filter_off": "Verwenden Sie die Suchschaltfläche, um zu suchen. Wenn mehr als 25 Suchergebnisse angezeigt werden müssen ist eine Live-Suche nicht möglich",
    "add_booking": "Buchung erstellen",
    "add_voucher": "Voucher erstellen",
    "add_flight": "Fahrt erstellen",
    "privacy_policy": "Datenschutzbestimmungen",
    "terms": "Bedingungen",
    "sign in to use your Quick Release Account": "Melden Sie sich an, um Ihr Quick Release-Konto zu verwenden",
    "your username and password didn't match": "Ihr Benutzername und Ihr Passwort stimmen nicht überein",
    "please try again": "Bitte versuchen Sie es erneut",
    "username": "Benutzername",
    "password": "Passwort",
    "sign_in": "Anmelden",
    "send_PIN": "PIN senden",
    "use_PIN": "PIN verwenden",
    "pin_successfully_sent": "PIN erfolgreich gesendet",
    "use_password": "Passwort verwenden",
    "send_email": "E-Mail senden",
    "email": "E-Mail",
    "send_email_to": "Empfänger auswählen",
    "select_template": "Vorlage auswählen",
    "sent": "gesendet",
    "waiting": "sendet",
    "error": "senden fehlgeschlagen",
    "pin": "PIN",
    "verification_code": "Bestätigungscode",
    "verification_code_subtitle": "Geben Sie den 6-stelligen Code ein, den Sie per E-Mail erhalten haben",
    "resend_code": "Code erneut senden",
    "resend_code_disabled": "Code in 30 Sekunden erneut senden",
    "code_required": "Code ist erforderlich",
    "code_pattern": "Muss 6 Ziffern sein",
    "verify_code": "Code verifizieren",
    "trust_device": "Dieses Gerät wird für 60 Tage vertraut. In den nächsten 60 Tagen wird keine Verifizierungscode mehr benötigt, um sich anzumelden",
    "sign_out": "Abmelden",
    "save": "Speichern",
    "save_and_back": "Speichern und zurück",
    "cancel": "Abbrechen",
    "previous": "vorheriger",
    "delete": "löschen",
    "refresh": "aktualisieren",
    "new_version_available": "eine neue Version von Quick Release ist verfügbar",
    "today": "heute",
    "classic": "zurück zur alten Schnittstelle",
    "month": "Monat",
    "week": "Woche",
    "morning_flights": "Morgenfahrten heute",
    "evening_flights": "Abendfahrten heute",
    "morning_flights_tomorrow": "Morgenfahrten morgen",
    "yesterday_flights": "Abendfahrten gestern",
    "action": "Aktion",
    "version": "Version",
    "messages": "Nachrichten",
    "assign": "zuordnen",
    "assigned": "zugewiesen",
    "assign_to": "Fahrt zuweisen",
    "close": "Schließen",
    "apps": "Ressourcen",
    "more": "mehr"
  },
  "CALENDAR": {
    "MATRIX": {
      "plan_flight": "Fahrt planen",
      "flyability_flight_location": "Flyability-Warnung für den Startort dieser Fahrt",
      "pilot": "Pilot",
      "driver_be": "Fahrer (BE)",
      "crew": "Crew",
      "occupancy": "Belegung bestätigt / hinzugefügt",
      "cancelled": "storniert",
      "conflict_tooltip": "mehrere Fahrten im selben Tagesabschnitt — zum Lösen in den Tagesplaner klicken",
      "morning": "Morgen",
      "evening": "Abend",
      "weather_anchor": "Wetter & Sonne: Standardstartort",
      "weather_anchor_tooltip": "Tageswetter und Sonnenzeiten gelten für den Standardstartort; Fahrtzellen zeigen die Flyability ihres eigenen Startorts",
      "no_default_location": "Standardstartort festlegen, um Tageswetter und Sonnenzeiten zu sehen",
      "sunrise_tooltip": "Sonnenaufgang am Standardstartort",
      "sunset_tooltip": "Sonnenuntergang am Standardstartort",
      "open_bookings": "offene Buchungen",
      "load_more": "mehr laden",
      "already_assigned_tooltip": "bereits diesem Flug zugewiesen — anderswo ablegen verschiebt sie, nie doppelt",
      "open": "offen",
      "events": "Events",
      "seats": "Plätze",
      "move_overflow_title": "zu wenig Kapazität",
      "move_overflow_body": "Der Zielballon hat weniger Plätze als Passagiere auf dieser Fahrt. Trotzdem verschieben?",
      "flights": "Fahrten",
      "available": "verfügbar",
      "no_availability_info": "keine Verfügbarkeitsinfo für diesen Tagesabschnitt",
      "edit_hint": "Infofeld einer Karte anklicken, um es im Pop-up zu bearbeiten — vollständige Bearbeitung über das Fahrtdetail",
      "location": "Startort",
      "pilot_crew": "Pilot & Crew",
      "weather": "Wetter",
      "lift": "Lift",
      "comment": "Kommentar",
      "edit_in_popup": "im Pop-up bearbeiten",
      "assign": "— zuweisen",
      "move": "verschieben",
      "flight_detail": "Fahrtdetail",
      "drop_bookings_here": "noch keine Buchungen — hierher ziehen",
      "search_placeholder": "nach Name, Telefon oder Kommentar suchen…",
      "search_hint": "Enter — sucht serverseitig",
      "no_open_bookings": "keine offenen Buchungen für diesen Tagesabschnitt",
      "waiting_list_hint": "zugewiesene Buchung hierher ziehen, um sie zu lösen",
      "back_to_classic": "zurück zum klassischen Dashboard",
      "previous_week": "vorige Woche",
      "next_week": "nächste Woche",
      "this_week": "diese Woche",
      "classic_until": "verfügbar bis 31. März 2027",
      "try_matrix_banner": "Probieren Sie das neue Dashboard mit Wochenplanung — ab 31. März 2027 der Standard.",
      "try_matrix": "ausprobieren",
      "create": "anlegen",
      "hour_derived": "automatisch: Sonnenauf-/-untergang am gewählten Startort, inkl. Offset",
      "hour": "Uhrzeit",
      "date": "Datum",
      "period": "Tagesabschnitt",
      "balloon": "Ballon"
    },
    "waiting_list": "Warteliste",
    "no_bookings_yet": "noch keine Buchungen",
    "drag_and_drop_reservations_here_to_add_to_this_flight": "ziehen Sie Buchungen hierher, um sie zu dieser Fahrt hinzuzufügen",
    "drag_and_drop_reservations_here_to_remove_from_this_flight": "ziehen Sie Buchungen hierher, um sie von dieser Fahrt zu löschen",
    "good_job": "Gute Arbeit!",
    "all_bookings_are_added_to_a_flight": "alle Buchungen wurden zu einer Fahrt hinzugefügt",
    "you_cannot_drop_bookings_here": "Sie können hier keine Buchungen vornehmen",
    "show_calendar_crew": "Crew-Kalender ansehen",
    "set_month": "gesamten Monat setzen",
    "clear_month": "alles löschen",
    "plan": "plan",
    "refetch": "aktualisieren",
    "show_all_pilots": "alle Piloten anzeigen",
    "show_all_crew": "alle Crew anzeigen"
  },
  "ACTORS": {
    "COM": "CPL",
    "NCO": "PPL",
    "NOL": "keine Lizenz",
    "NOA": "kein Zugang",
    "OPR": "Betreiber",
    "CRE": "Pilot/Crew (nur zugewiesene Fahrten)",
    "REP": "Berichtviewer",
    "ASS": "Betreiber Assistent (Fahrten & Reservierungen)",
    "MET": "Wetterfrosch (nur Fahrten)",
    "user_role": "Benutzerrolle",
    "name": "Name",
    "phone": "Telefon (internationales Format: +491721234567)",
    "email": "E-Mail",
    "used_for_login": "für die Anmeldung verwendet",
    "emailNotifications": "E-Mail-Benachrichtigungen",
    "emails_from_the_system_will_be_send_to_this_address": "E-Mails aus dem System werden an diese Adresse gesendet, nicht an die Login-Adresse",
    "driver_license": "Führerschein",
    "driver_license_none": "kein",
    "pilot_license": "Pilotenlizenz ",
    "ground_crew": "Bodenpersonal",
    "language": "Sprache",
    "confirm_message": "Sind Sie sicher, dass Sie löschen möchten?",
    "confirm": "bestätigen",
    "contacts": "Kontakte",
    "update": "Update",
    "delete": "löschen",
    "save": "speichern",
    "add_contact": "Kontakt hinzufügen",
    "crew": "Crew",
    "pilot": "Pilot",
    "add_crew": "Crew hinzufügen",
    "national_license": "nationale Lizenz",
    "part_fcl_license": "PART-FCL-Lizenz",
    "license_group_A": "Gruppe A",
    "license_group_B": "Gruppe B",
    "license_group_C": "Gruppe C",
    "license_group_D": "Gruppe D",
    "license_gas": "Gasballon",
    "license_number": "Lizenznummer",
    "license_expiry_date": "Ablaufdatum der OPC / Lizenz",
    "license_extra_crew": "Lizenz für Extrabesatzung",
    "ground_crew_training_expiry_date": "Schulung Bodenpersonal läuft ab am",
    "first_aid_expiry_date": "Ablaufdatum First Aid",
    "fire_extinguisher_expiry_date": "Ablaufdatum Feuerlöscher",
    "medical_expiry_date": "Ablaufdatum Medical",
    "weight": "Gewicht",
    "warning_not_current": "Die Gültigkeit läuft in weniger als 30 Tagen ab, überprüfen Sie die Ablaufdaten",
    "error_not_current": "Gültigkeit abgelaufen, überprüfen Sie die Ablaufdaten",
    "assigned_to_flight": "Dieser Fahrt zugewiesen",
    "your_flight": "Deine Fahrt",
    "your_flights": "Deine Fahrten",
    "pilots": "Piloten",
    "drivers": "BE-crew"
  },
  "BALLOONS": {
    "upload_photo": "Foto hochladen",
    "name": "Name",
    "call_sign": "Kennzeichen",
    "capacity": "Kapazität",
    "total_weight": "Gesamtgewicht",
    "balloons": "Ballone",
    "confirm_message": "Sind Sie sicher, dass Sie löschen wollen?",
    "confirm": "bestätigen",
    "update": "Update",
    "delete": "löschen",
    "save": "speichern",
    "add_balloon": "Ballon erstellen",
    "group": "Gruppe",
    "MLM": "MTM (Minimum Landing Mass / Minimale Landemasse)",
    "MTOM": "MTOM (Maximum Take-Off Mass / Maximale Startmasse)",
    "lift_warning_title": "Lift-Warnzonen",
    "lift_warning_explain": "Farbe der Tragkraftreserve pro Fahrt: zweifelhaft (orange) ab dem ersten Wert, gut (grün) ab dem zweiten — unter der orangen Grenze wird die Fahrt rot. Blau erscheint, wenn die Fahrt unter der MLM landen könnte.",
    "lift_warning_unconfigured": "nicht konfiguriert — nur eine negative Reserve wird rot angezeigt",
    "lift_zone_red": "zu niedrig",
    "lift_zone_orange": "zweifelhaft",
    "lift_zone_green": "gut",
    "lift_orange_from": "zweifelhaft (orange) ab",
    "lift_good_from": "gut (grün) ab",
    "min_fuel": "durchschnittlicher Verbrauch (Liter pro Stunde)",
    "liter_per_hour": "Liter pro Stunde",
    "fuel": "Verbrauch bei 20 °C und maximaler Anzahl von Passagieren",
    "envelope": "Hülle",
    "envelope_manufacturer": "Hersteller Hülle",
    "envelope_type": "Typ Hülle",
    "envelope_volume": "Volumen Hülle",
    "envelope_weight": "Gewicht Hülle",
    "envelope_hours": "Stunden Hülle",
    "envelope_inspection_date": "ARC/Jahreskontrolle gültig bis",
    "balloon_temp": "Temperatur Hülle",
    "burner": "Brenner",
    "burner_manufacturer": "Hersteller Brenner ",
    "burner_type": "Typ Brenner",
    "burner_weight": "Gewicht Brenner",
    "cylinder_hint": "Speichern Sie den Ballon zuerst und fügen Sie dann Zylinder hinzu. Stellen Sie sicher, dass Sie zuerst die Zylinder im System erstellen. Die gleichen Zylinder können auf mehreren Ballonen verwendet werden",
    "cylinder": "Zylinder",
    "cylinder_manufacturer": "Hersteller",
    "cylinder_volume": "Volumen",
    "cylinder_count": "Anzahl",
    "cylinder_empty_weight": "Leergewicht",
    "cylinder_full_weight": "volles Gewicht",
    "cylinder_total_weight": "Gesamtgewicht",
    "cylinder_number": "Nummer",
    "cylinder_serial": "Seriennummer",
    "basket": "Korb",
    "basket_manufacturer": "Hersteller Korb ",
    "basket_type": "Typ Korb",
    "basket_weight": "Gewicht Korb",
    "insurance_company": "Versicherungsgesellschaft",
    "insurance_due_date": "Ablaufdatum der Versicherung",
    "add_cylinder": "Zylinder hinzufügen",
    "error_not_current": "Ballon gegroundet, aktualisieren Sie die Ablaufdaten",
    "warning_not_current": "Ballon läuft in weniger als 30 Tagen ab, aktualisieren Sie die Verfallsdaten"
  },
  "VOUCHERS": {
    "status": "Status",
    "create_booking": "Buchung erstellen",
    "available": "verfügbar",
    "used": "verwendet",
    "expired": "abgelaufen",
    "voucher_type": "Typ",
    "show_all_types": "alle Typen anzeigen",
    "voucher_reference": "Referenz",
    "issue_date": "Ausgabedatum",
    "expiry_date": "Ablaufdatum",
    "contactName": "Kontaktname",
    "contactPhone": "Telefon",
    "contactLanguage": "Sprache",
    "contactEmail": "E-Mail",
    "contact_city": "Stadt",
    "recipient_info": "Details der Person, die den Gutschein erhalten und verwenden wird",
    "buyer_info": "Details der Person, die den Gutschein gekauft hat",
    "details_info": "spezifische Informationen zum Gutschein selbst",
    "buyer": "gekauft von",
    "recipient": "Empfänger",
    "recipientName": "Name des Empfängers",
    "recipientPhone": "Telefon",
    "recipientLanguage": "Sprache",
    "recipientEmail": "E-Mail",
    "recipientAddress": "Adresse",
    "recipientPostalCode": "Postleitzahl",
    "recipientCity": "Stadt",
    "recipientCountry": "Land",
    "details": "details",
    "comments": "Kommentare",
    "paymentAmount": "Betrag",
    "paymentStatus": "Zahlungsstatus",
    "paymentDate": "Zahlungsdatum",
    "adults": "Erwachsene",
    "children": "Kinder",
    "external": "extern",
    "external_source": "Quelle",
    "tickets": "Tickets",
    "voucher": "Voucher",
    "available_vouchers": "verfügbare Voucher",
    "confirm_message": "sind Sie sicher, dass Sie dieses Voucher löschen wollen?",
    "unpaid_vouchers": "Achtung! Es gibt unbezahlte Voucher",
    "IMPORT": {
      "import": "importieren",
      "upload_csv": "CSV hochladen",
      "upload_valid_csv_with_this_header": "eine gültige CSV-Datei mit der folgenden Kopfzeile hochladen",
      "example_with_2_adults": "Beispiel für einen Voucher mit 2 Erwachsenen",
      "choose_file": "Datei auswählen",
      "check_file": "Datei prüfen",
      "check_errors": "Fehler prüfen",
      "not_a_valid_CSV": "dies ist keine gültige CSV-Datei",
      "valid_CSV": "keine Validierungsfehler",
      "click_import": "Import anklicken",
      "number_of_vouchers": "Anzahl der Voucher",
      "import_status": "Importstatus",
      "imported_succesfully": "erfolgreich importiert",
      "imported_with_errors": "Fehler beim Import",
      "finish": "fertigstellen",
      "row": "Zeile",
      "error_more_less_columns": "mehr oder weniger Spalten als erwartet",
      "error_header": "Fehler in der Kopfzeile",
      "error_contact_name": "Fehler in contactName, dieses Feld ist ein Pflichtfeld",
      "error_contact_phone": "Fehler in contactPhone, dieses Feld ist ein Pflichtfeld und hat das Format M:+32...",
      "error_contact_language": "Fehler in contactLanguage, dieses Feld ist ein Pflichtfeld",
      "error_voucher_type": "Fehler in Vouchertyp, dieses Feld ist ein Pflichtfeld",
      "error_voucher_reference": "Fehler in Voucherreferenz, dieses Feld ist ein Pflichtfeld",
      "error_issue_date": "Fehler im Ausstellungsdatum, dieses Feld ist ein Pflichtfeld und hat das Format JJJJ-MM-TT",
      "error_expiry_date": "Fehler im Verfallsdatum, dieses Feld ist ein Pflichtfeld und hat das Format JJJJ-MM-TT",
      "error_payment_date": "Fehler im Zahlungsdatum, dieses Feld ist ein Pflichtfeld und hat das Format JJJJ-MM-TT",
      "error_payment_status": "Fehler im Zahlungsstatus, dieses Feld ist ein Pflichtfeld und die akzeptierten Werte sind OPEN oder PAID",
      "error_payment_type": "Fehler bei der Zahlungsart, dieses Feld ist ein Pflichtfeld und die akzeptierten Werte sind NOPA, CASH, WIRE, BANC, CRED, ONLI",
      "error_adults": "Fehler bei Erwachsenen, dies muss eine Zahl sein",
      "error_children": "Fehler bei Kindern, dies muss eine Zahl sein",
      "error_import": "Fehler beim Import",
      "succes_import": "erfolgreich importiert",
      "cancel": "abbrechen"
    }
  },
  "BOOKINGS": {
  	"email_export_tooltip_open_amount": "mit offenem Saldo",
    "email_passengers": "Passagiere per E-Mail",
    "email_export_tooltip": "Passagier-E-Mail-Adressen als CSV exportieren",
    "email_export_tooltip_dynamic": "Alle Passagier-E-Mail-Adressen herunterladen ({{filter}}){{extras}}",
    "email_export_tooltip_tags": "mit Tag {{tags}}",
    "email_export_tooltip_search": "passend zu '{{search}}'",
    "email_export_success": "{{count}} E-Mail-Adressen exportiert",
    "email_export_empty": "Keine E-Mail-Adressen zum Exportieren",
    "id": "ID",
    "availability": "Verfügbarkeit",
    "PERI": "Verfügbarkeit zu jedem Datum",
    "DATE": "Verfügbarkeit zu einem bestimmten Datum",
    "MOR": "Morgen",
    "EVE": "Abend",
    "mo": "Mo",
    "tu": "Di",
    "we": "Mi",
    "th": "Do",
    "fr": "Fr",
    "sa": "Sa",
    "su": "So",
    "save": "speichern",
    "child": "Kind",
    "name": "Name",
    "age": "das Alter",
    "transport": "Transport",
    "age_amount": "Jahre",
    "weight": "Gewicht",
    "luggage": "Gepäck",
    "paymentType": "Zahlungsart ",
    "paymentReference": "Zahlungsreferenz ",
    "paymentAmount": "Zahlungsbetrag",
    "paymentStatus": "Zahlungsstatus",
    "paymentDate": "Zahlungsdatum",
    "delete": "löschen",
    "OPEN": "öffnen",
    "UNK": "hinzugefügt",
    "INV": "eingeladen",
    "CON": "bestätigt",
    "completed": "abgeschlossen",
    "CAN": "storniert",
    "CPP": "gewerbliche Privatpassagiere",
    "COP": "gewerbliche Passagiere",
    "NCP": "nicht-gewerbliche Passagiere",
    "booking_date": "Buchungsdatum",
    "days_expired": "{{ d }} Tage abgelaufen",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "status": "Status",
    "bookingType": "Buchungsart",
    "bookingCode": "Buchungsreferenz",
    "bookingCodeHint": "Klicken Sie, um die App für Passagiere zu öffnen",
    "bookingCodeMissingEmail": "ohne E-Mail haben die Passagiere keinen Zugriff auf die Buchung in der Passagier-App ",
    "commentsTitle": "Kommentare",
    "comments": "Intern Kommentare",
    "pax_comments": "Passagier Kommentare",
    "region": "Region",
    "source": "Quelle",
    "new_source": "neue Quelle",
    "you_can_manage_all_sources_in_settings": "Sie können alle Quellen in den Einstellungen verwalten",
    "source_validation": "Quelle ist ein Pflichtfeld, mindestens 3, maximal 50 Zeichen und muss eindeutig sein",
    "source_list_validation": "wählen Sie eine Quelle aus der Liste oder erstellen Sie zuerst eine neue Quelle",
    "source_list_empty": "keine Quellen gefunden, bitte zuerst eine Quelle erstellen",
    "locationType": "Standort",
    "REGI": "alle Standorte in einer Region",
    "FIXE": "bestimmter Standort in einer Region",
    "PRIV": "privater Standort",
    "logsRemoved": "Anzahl vorheriger Entfernungen aus Fahrt",
    "contactPerson": "Kontaktperson",
    "contactName": "Kontaktname ",
    "contactPhone": "Telefonnummer Kontakt (internationales Format: +491721234567)",
    "contactEmail": "E-Mail Kontakt ",
    "contactLanguage": "Sprache Kontakt ",
    "action_needed": "Aktion erforderlich",
    "answer_flight_yes_no": "FAHRT JA oder FAHRT NEIN antworten",
    "flight_yes": "FAHRT JA",
    "flight_no": "FAHRT NEIN",
    "PAID": "bezahlt",
    "REFUNDED": "erstattet",
    "CASH": "bar",
    "COUP": "Voucher (in System)",
    "VOUC": "Voucher",
    "NOPA": "keine Zahlung",
    "WIRE": "Überweisung",
    "BANC": "Kontakt Bank",
    "CRED": "Kreditkarte",
    "ONLI": "online",
    "INVO": "Rechnung",
    "CHEQ": "Scheck",
    "only_available_with_paymenttype_voucher": "nur mit Zahlungsart Voucher",
    "bookings": "Buchungen",
    "booking": "Buchung",
    "confirm": "bestätigen",
    "update": "Update",
    "contact": "Kontakt",
    "passengers": "Passagiere",
    "cancel": "abbrechen",
    "next": "weiter",
    "flightDate": "Fahrtdatum",
    "flightPeriod": "Fahrtzeit",
    "flight_balloon": "Ballon",
    "flight_location": "Startort",
    "flight_pilot": "Pilot",
    "add_passenger": "Passagier hinzufügen",
    "messages": "Nachrichten",
    "no_bookings_found": "keine Buchungen gefunden",
    "inviteCount": "lädt ein",
    "confirm_message": "sind Sie sicher, dass Sie diese Buchung löschen wollen?",
    "delete_blocked_on_flight": "Entfernen Sie diese Buchung zuerst aus der Fahrt, bevor Sie sie löschen können.",
    "always_available": "immer verfügbar",
    "limited_availability": "begrenzte Verfügbarkeit",
    "end_before": "Fahrt vor",
    "passenger": "Passagier",
    "details": "Details",
    "payment_details": "Zahlungen",
    "address_details": "Adressinfo",
    "disability": "Unterstützung erforderlich",
    "category": "Kategorie",
    "address": "Adresse",
    "postalCode": "Postleitzahl",
    "city": "Stadt",
    "country": "Land",
    "signature": "Unterschrift",
    "added_flight": "ausgewählte Fahrt",
    "select_flight": "Fahrt auswählen",
    "no_flight_added": "keine Fahrt ausgewählt",
    "no_flight_data": "Fahrtdaten werden nur angezeigt, wenn der Ort und das Datum feststehen",
    "available_flights": "verfügbare Fahrten",
    "no_available_flights": "keine Fahrten verfügbar",
    "available_balloons": "verfügbare Ballone",
    "no_available_balloons": "keine Ballone verfügbar",
    "totalAmount": "Gesamtbetrag",
    "paid_amount": "bezahlt",
    "openAmount": "offener Betrag",
    "prepayment": "Vorauszahlung",
    "prepaymentDate": "Vorauszahlungsdatum",
    "passengers_to_pay": "zu zahlende(r) Fahrgast/Fahrgäste",
    "default_weight_warning": "Standardgewicht - Bestätigung erforderlich",
    "passengers_with_default_weight": "{{ count }} Passagier(e) mit Standardgewicht",
    "confirm_weight": "Gewicht bestätigen",
    "mark_paid": "als bezahlt kennzeichnen",
    "remove_from_passengerlist": "aus der Passagierliste entfernen",
    "add_to_passengerlist": "zusätzlichen Passagier hinzufügen",
    "checkin_passengers": "zurück zum Einchecken",
    "view_checked_in": "eingecheckte Pax anzeigen",
    "hide_checked_in": "eingecheckte Pax ausblenden",
    "check_in_all": "alle einchecken",
    "import": "importieren",
    "upload_csv": "CSV hochladen",
    "upload_valid_csv_with_this_header": "eine gültige CSV-Datei mit der folgenden Kopfzeile hochladen",
    "example_in_region_with_id_1_with_2_adults_and_0_children": "Beispiel für eine Buchung mit 2 Erwachsenen in der Region mit Id 1",
    "choose_file": "Datei auswählen",
    "check_file": "Datei prüfen",
    "check_errors": "die folgenden Fehler zu korrigieren",
    "not_a_valid_CSV": "dies ist keine gültige Datei",
    "valid_CSV": "es liegen keine Fehler vor",
    "click_import": "zum Importieren klicken",
    "number_of_bookings": "Anzahl der Buchungen",
    "number_of_objects_upcoming": "Anzahl bevorstehenden",
    "number_of_objects_history": "Anzahl beendet",
    "import_status": "Importstatus",
    "imported_succesfully": "erfolgreich importiert",
    "imported_with_errors": "Fehler beim Import",
    "finish": "fertigstellen",
    "row": "Zeile",
    "error_more_less_columns": "mehr oder weniger Spalten als erwartet",
    "error_header": "Fehler in der Kopfzeile",
    "error_contact_name": "Fehler in contactName, dieses Feld ist ein Pflichtfeld",
    "error_contact_phone": "Fehler in contactPhone, dieses Feld ist ein Pflichtfeld und hat das Format M:+49...",
    "error_contact_language": "Fehler in contactLanguage, dieses Feld ist ein Pflichtfeld",
    "error_region": "Fehler in der Region, dieses Feld ist ein Pflichtfeld und muss die ID der Region enthalten",
    "error_adults": "Fehler bei Erwachsenen, dies muss eine Zahl sein",
    "error_children": "Fehler bei Kindern, dies muss eine Zahl sein",
    "errorImport": "Fehler beim Import",
    "succesImport": "erfolgreich importiert",
    "flight_confirmation": "Fahrtbestätigung",
    "date_filter_is_yyyy-mm-dd": "Datumsfilter = jjjj-mm-tt",
    "FILTER": {
    	"standard": "alle aktiven",
    	"standard_desc": "alles, was noch fahren muss",
    	"toPlan": "noch einzuplanen",
    	"toPlan_desc": "noch keine Fahrt",
    	"toConfirm": "zu bestätigen",
    	"toConfirm_desc": "vom Passagier angefragt",
    	"invited": "eingeladen",
    	"invited_desc": "wartet auf Antwort des Passagiers",
    	"confirmed": "bestätigt",
    	"confirmed_desc": "fest auf einer Fahrt",
    	"expired": "abgelaufen",
    	"expired_desc": "Gültigkeit vorbei, noch nicht gefahren",
    	"history": "abgeschlossen",
    	"history_desc": "gefahren oder storniert"
    },
    "import_bookings": "Buchungen importieren (CSV)",
    "expired_on_flight_date": "am Fahrtdatum nicht mehr gültig",
    "flight_confirmed": "Fahrt bestätigt",
    "invited_waiting_answer": "eingeladen, wartet auf Antwort",
    "MERGE": {
      "merge": "zusammenführen",
      "load": "laden",
      "restart": "neustarten",
      "select_booking": "Buchungen auswählen",
      "select_booking_hint": "die Buchung auf der linken Seite wird gelöscht, die Buchung auf der rechten Seite wird gespeichert",
      "merge_booking": "Buchungen zusammenführen",
      "merge_booking_hint": "Ihre Zustimmung geben, bevor Sie speichern und löschen können",
      "booking_id_to_delete": "zu löschende Buchungs-ID",
      "booking_id_to_merge": "zusammenzuführende Buchungs-ID",
      "error_loading": "Fehler beim Laden, wählen Sie eine andere ID oder starten Sie neu",
      "warning_to_switch": "Warnung: Sie entscheiden sich dafür, die letzte Reservierung zu löschen",
      "save_and_delete": "diese Reservierung speichern und löschen",
      "confirm_to_delete": "Zustimmung zur Löschung",
      "replace": "ersetzen",
      "add": "hinzufügen",
      "undo": "rückgängig machen",
      "fields_are_identical": "Felder sind identisch",
      "remove": "entfernen"
    },
    "LOG": {
      "logbook": "Logbuch",
      "outbox": "gesendete E-Mails",
      "only_logs_from_UI": "Protokollierung von Quick Release (nicht von UP oder von der Website)",
      "ADDE": "zur Fahrt hinzugefügt",
      "REMO": "von Fahrt entfernt",
      "CONF": "für Fahrt bestätigt",
      "cancel": "Fahrt storniert, auf Buchungsliste verschoben",
      "COMP": "Fahrt durchgeführt, in die Historie verschoben (abgeschlossen)",
      "INVI": "per MSG zum Fahrt eingeladen",
      "CREA": "Buchung im System angelegt",
      "update": "Buchung aktualisiert (ein oder mehrere Felder)",
      "DELE": "Buchung aus dem System gelöscht",
      "MAIL": "E-Mail gesendet",
      "TRANSFER": "in einen anderen Korb verschoben",
      "view_email": "E-Mail anzeigen",
      "flight": "Fahrt"
    },
    "invoice_name": "Rechnungsname",
    "vat_number": "Steuernummer"
  },
  "COMMUNICATIONS": {
    "RETENTION": {
      "title": "Aufbewahrung von Nachrichten",
      "explanation": "Wählen Sie, wie lange Nachrichten aufbewahrt werden. Ältere Nachrichten verschwinden sofort vom Dashboard und werden nach 90 Tagen endgültig gelöscht — innerhalb dieser 90 Tage können Sie sie durch Zurücksetzen der Einstellung wiederherstellen. Nachrichten offener Buchungen bleiben immer erhalten. Als Verantwortlicher wählen und begründen Sie die Aufbewahrungsfrist selbst.",
      "closedBookings": "abgeschlossene Buchungen",
      "crew": "Crew",
      "never": "nie (immer aufbewahren)",
      "years": "Jahre",
      "year": "Jahr",
      "recommended": "empfohlen: 2 Jahre",
      "recommendedShort": "empfohlen",
      "confirmTitle": "alte Nachrichten löschen?",
      "confirmBody": "{{total}} Nachrichten ({{closedBookingMessages}} aus abgeschlossenen Buchungen, {{crewMessages}} von der Crew) verschwinden jetzt und werden nach 90 Tagen endgültig gelöscht. Innerhalb dieser 90 Tage können Sie sie durch Zurücksetzen der Einstellung wiederherstellen; danach sind sie unwiederbringlich weg.",
      "policyClosedYears": "Nachrichten abgeschlossener Buchungen werden gelöscht, sobald die Nachricht selbst älter als {{years}} Jahr(e) ist.",
      "policyClosedNever": "Nachrichten abgeschlossener Buchungen werden für immer aufbewahrt. Achtung: dadurch kann keine neue WhatsApp-Verbindung hergestellt werden.",
      "policyCrewYears": "Crew-Nachrichten werden gelöscht, sobald die Nachricht selbst älter als {{years}} Jahr(e) ist.",
      "policyCrewNever": "Crew-Nachrichten werden für immer aufbewahrt.",
      "pendingDeletion": "{{count}} Nachrichten sind zur Löschung vorgemerkt — in {{days}} Tagen werden sie endgültig gelöscht.",
      "connectBlocked": "Um WhatsApp zu verbinden, muss zuerst eine Aufbewahrungsfrist für Nachrichten abgeschlossener Buchungen festgelegt werden (siehe „Aufbewahrung von Nachrichten\" unten)."
    },
    "sent_at": "gesendet am",
    "phone": "Telefon",
    "name": "Name",
    "text": "Text",
    "status": "Status",
    "message_id": "Nachrichten-ID",
    "message_price": "Nachrichtenpreis",
    "network": "Netzwerk",
    "remaining_balance": "Restsaldo",
    "received_at": "erhalten am",
    "msisdn": "msisdn",
    "message_timestamp": "Zeitstempel der Nachricht",
    "keyword": "Stichwort",
    "pilot_invitation_sms": "MSG an Piloten",
    "crew_invitation_sms": "MSG an Crew",
    "checkin_notification_sms": "Check-in-Einladung",
    "booking_confirmation_sms": "Reservierungsbestätigung",
    "passenger_invitation_sms": "MSG an Fahrgäste",
    "cancel_sms": "MSG zum Canceln",
    "reminder_sms": "MSG zur Erinnerung",
    "reminder_wa": "WhatsApp zur Erinnerung",
    "sms_in": "eingehende SMS",
    "messages": "Nachrichten",
    "flight": "Fahrt",
    "booking": "Buchungen",
    "crew": "crew",
    "sms_out": "ausgehende SMS",
    "to": "an",
    "unanswered_messages": "unbeantwortete Nachrichten",
    "mark_all_as_read": "markiere alle {0} Nachrichten als gelesen",
    "mark": "Nachrichten",
    "mark_all": "alles markieren",
    "mark_paid": "als bezahlt markieren",
    "mark_not_paid": "als nicht bezahtlt markieren",
    "messages_as_read": "als gelesen markieren",
    "you": "sie",
    "mail_copy": "Kopie senden",
    "action_succeed": "aktion erfolgreich",
    "accepted": "akzeptiert",
    "delivered": "geliefert",
    "sent": "gesendet",
    "failed": "konnte nicht geliefert werden",
    "unknown": "unbekannter Fehler",
    "retry": "später wiederholen",
    "wrongnumber": "falsche Nummer",
    "none": "keiner",
    "fallback_hint": "WhatsApp offline — SMS-Guthaben verfügbar. SMS-Fallback in den Einstellungen aktivieren.",
    "WHATSAPP": {
      "CHANNEL": {
          "chooser": "WhatsApp-Kanal",
          "free": "WhatsApp gratis",
          "freeHint": "gekoppeltes Gerät — kostenlos, aber inoffiziell; Meta kann es sperren",
          "business": "WhatsApp Business",
          "businessHint": "offizieller Meta-Kanal über Ihr eigenes Meta-Konto — keine Sperrungen, kostenpflichtig pro Nachricht",
          "active": "aktiv",
          "settingUp": "wird eingerichtet",
          "freeInactiveExplain": "WhatsApp Business ist derzeit Ihr aktiver Kanal. Um zu WhatsApp gratis zurückzukehren, wird Ihre Nummer von der Meta-API getrennt und Sie koppeln Ihr Telefon anschließend erneut per QR-Code. SMS-Fallback überbrückt den Übergang. Achtung: Der Gratis-Kanal kann von Meta erneut gesperrt werden."
      },
      "CLOUD": {
          "dialogWindowNote": "Empfänger, die Ihnen in den letzten 24 Stunden nicht geschrieben haben, erhalten den genehmigten Vorlagentext; Ihre Änderungen erreichen nur Empfänger innerhalb des 24-Stunden-Fensters.",
          "windowAllOpen": "Alle Empfänger sind innerhalb des 24-Stunden-Fensters — Ihr Text wird genau so über WhatsApp versendet.",
          "windowSomeClosed": "{{count}} von {{total}} Empfänger(n) sind außerhalb des 24-Stunden-Fensters — sie erhalten den genehmigten Vorlagentext.",
          "windowEditedWarning": "Achtung: Sie haben den Text geändert. Die {{count}} Empfänger außerhalb des 24-Stunden-Fensters erhalten trotzdem den GENEHMIGTEN VORLAGENTEXT — Ihre Änderung erreicht nur Empfänger innerhalb des Fensters.",
          "auxTemplateOutOfWindow": "Empfänger außerhalb des 24-Stunden-Fensters erhalten den UP-Link und die Fahrtvorschläge als feste Vorlagennachricht (Text von Quick Release festgelegt, nicht änderbar).",
          "noFlightTypesHidden": "Für diese Reservierung ist noch keine Fahrt geplant — Vorlagen mit Fahrtdaten (Einladung, Erinnerung, Check-in, Stornierung) sind daher ausgeblendet.",
          "windowClosedFreeform": "Außerhalb des 24-Stunden-Fensters — Vorlage verwenden.",
          "templatePickerButton": "Vorlage",
          "title": "WhatsApp-Kanal",
          "subtitle": "Wählen Sie, wie WhatsApp-Nachrichten versendet werden: WhatsApp gratis (gekoppeltes Gerät) oder WhatsApp Business (offiziell, über Ihr eigenes Meta-Konto). Ein Wechsel ist in beide Richtungen möglich.",
          "intro": "WhatsApp Business versendet Ihre Nachrichten über die offizielle Meta-API: kein gekoppeltes Telefon, kein Sperrrisiko und Zustellbestätigungen pro Nachricht.",
          "introBilling": "Es ist ein kostenpflichtiger Kanal: Sie verbinden Ihr eigenes Meta-Geschäftskonto mit Ihrer eigenen Zahlungsmethode, und Meta rechnet direkt mit Ihnen ab. Quick Release berechnet für diese Nachrichten nichts.",
          "introCostEstimate": "Schätzung auf Basis Ihrer Nachrichten der letzten {{months}} Monate: ± {{cost}} pro Monat. Im Durchschnitt haben Sie {{total}} WhatsApp-Nachrichten pro Monat gesendet, davon ± {{billable}} außerhalb des 24-Stunden-Fensters — nur diese sind kostenpflichtig (± 0,03 € pro Nachricht); Nachrichten innerhalb von 24 Stunden nach einer Kundenantwort sind kostenlos.",
          "introCostEstimateSms": "Schätzung auf Basis Ihres SMS-Verlaufs der letzten {{months}} Monate: ± {{cost}} pro Monat. Im Durchschnitt haben Sie {{total}} Nachrichten pro Monat gesendet, davon ± {{billable}} außerhalb des 24-Stunden-Fensters — nur diese sind kostenpflichtig (± 0,03 € pro Nachricht); Nachrichten innerhalb von 24 Stunden nach einer Kundenantwort sind kostenlos.",
          "introTemplates": "Nachrichten außerhalb eines 24-Stunden-Kundenfensters laufen über Ihre genehmigten Nachrichtenvorlagen; Antworten innerhalb des Fensters bleiben Freitext und kostenlos.",
          "startSignup": "mit Meta verbinden",
          "reconnectMeta": "Meta-Konto neu verbinden",
          "signupCancelled": "Die Meta-Verbindung wurde nicht abgeschlossen. Ihre aktuellen WhatsApp-Einstellungen sind unverändert.",
          "signupSuccess": "WhatsApp-Business-Konto verbunden {{phone}}. Ihre Nachrichtenvorlagen werden vorbereitet.",
          "provisioningIntro": "Ihr Meta-Konto ist verbunden. Schließen Sie die folgenden Schritte ab und aktivieren Sie dann WhatsApp Business. Bis dahin nutzen Ihre Nachrichten den aktuellen Kanal.",
          "stepWaba": "WhatsApp-Business-Konto verbunden",
          "stepNumber": "Telefonnummer registriert",
          "stepPayment": "Zahlungsmethode in der Meta Business Suite hinterlegt",
          "stepTemplates": "Nachrichtenvorlagen von Meta genehmigt",
          "paymentExplain": "Meta rechnet direkt mit Ihnen über Ihr eigenes Konto ab. Hinterlegen Sie eine Zahlungsmethode in der Meta Business Suite (Abrechnung) und bestätigen Sie das hier. Ohne Zahlungsmethode werden Vorlagen-Nachrichten nicht mehr versendet.",
          "openMetaBilling": "Meta-Abrechnung öffnen",
          "paymentConfirm": "ich habe meine Zahlungsmethode hinterlegt",
          "paymentActionNeeded": "Meta meldet ein Zahlungsproblem auf Ihrem Konto. Nachrichten fallen auf SMS zurück. Prüfen Sie Ihre Zahlungsmethode in der Meta Business Suite und bestätigen Sie unten.",
          "activate": "WhatsApp Business aktivieren",
          "activateConfirmTitle": "WhatsApp Business aktivieren?",
          "activateConfirmBody": "Ab jetzt laufen Ihre WhatsApp-Nachrichten über die offizielle Meta-API auf Ihrem eigenen Konto. Ein Zurückwechseln ist jederzeit möglich.",
          "activateConfirmBodyNoPayment": "Sie haben noch keine Zahlungsmethode bestätigt. Kostenlose Nachrichten funktionieren, aber kostenpflichtige Vorlagen-Nachrichten fallen auf SMS zurück, bis Meta eine Zahlungsmethode hat. Trotzdem aktivieren?",
          "activated": "WhatsApp Business ist aktiv.",
          "activeTitle": "WhatsApp Business aktiv",
          "messagingTier": "Nachrichtenlimit",
          "templatesServing": "{{count}} Nachrichtenvorlage(n) genehmigt und im Einsatz.",
          "switchBack": "zurück zu WhatsApp gratis",
          "switchBackConfirmTitle": "Zurück zu WhatsApp gratis?",
          "switchBackConfirmBody": "Ihre Nummer wird von der Meta-API gelöst und Sie koppeln sie wieder als verknüpftes Gerät (QR-Code). Der SMS-Fallback überbrückt den Wechsel. Achtung: Der Gratis-Kanal kann von Meta erneut gesperrt werden.",
          "switchedBack": "Zurück zu WhatsApp gratis. Koppeln Sie Ihr Telefon mit dem QR-Code unten.",
          "statusApproved": "genehmigt",
          "statusPending": "wartet auf Genehmigung durch Meta",
          "statusPendingSince": "wartet seit {{elapsed}} auf Genehmigung durch Meta",
          "statusRejected": "von Meta abgelehnt",
          "statusBlocked": "Text muss angepasst werden",
          "fixWordingHint": "Passen Sie den Text im Bildschirm Nachrichtenvorlagen an und speichern Sie - er wird dann automatisch erneut bei Meta eingereicht.",
          "freeChannelNote": "WhatsApp gratis läuft über ein gekoppeltes Gerät auf einer inoffiziellen Verbindung; Meta kann diese sperren oder trennen. Erwägen Sie WhatsApp Business für einen garantierten Kanal.",
          "metaLinksHint": "Ihr Konto, Ihre Nummer und die Freigabe Ihrer Vorlagen liegen bei Meta — prüfen Sie sie im WhatsApp Manager in Ihrem eigenen Konto.",
          "openMetaAccount": "WhatsApp Manager öffnen",
          "openMetaTemplates": "Nachrichtenvorlagen bei Meta",
          "openMetaNumbers": "Telefonnummern bei Meta",
          "beforeYouStart": "bevor Sie starten, bei Meta",
          "prereqBusiness": "Ein Meta-Unternehmenskonto (Meta Business Portfolio) auf den Namen Ihres Unternehmens — legen Sie es zuerst an, falls noch nicht vorhanden.",
          "prereqPayment": "Eine Zahlungsmethode in diesem Meta-Konto: Meta stellt Ihnen die kostenpflichtigen Nachrichten direkt in Rechnung.",
          "prereqNumber": "Eine Telefonnummer für WhatsApp: eine neue Nummer oder Ihre bisherige WhatsApp-Business-Nummer (sie funktioniert auf Ihrem Telefon weiter).",
          "openMetaBusiness": "Meta Business öffnen",
          "openManual": "Handbuch lesen"
      },
      "settings": "Einstellungen",
      "whatsapp_OFF": "WhatsApp ist deaktiviert",
      "whatsapp_OFF_hint": "Kontaktieren Sie uns, um WhatsApp zu aktivieren, wenn Sie eine WhatsApp for Business-Nummer haben. WhatsApp über Ihre private Nummer wird nicht unterstützt.",
      "whatsapp_ON": "WhatsApp ist aktiviert",
      "whatsapp_ON_hint": "Alle Nachrichten werden über WhatsApp gesendet. Wählen Sie SMS als Backup, falls WhatsApp für Ihren Kunden nicht verfügbar ist.",
      "whatsapp_TRIAL": "WhatsApp ist im Testmodus",
      "whatsapp_TRIAL_hint": "Sie werden immer aufgefordert, zwischen SMS oder WhatsApp zu wählen.",
      "fallbackSMS": "Fallback auf SMS",
      "fallbackSMS_hint": "verwenden Sie SMS, wenn WhatsApp nicht verfügbar ist",
      "fallbackSMS_no_credits": "kein SMS-Guthaben verfügbar. Laden Sie auf, um SMS-Fallback zu aktivieren.",
      "connection": "Verbindung",
      "device_connected_successfully": "Gerät erfolgreich verbunden",
      "connect_your_device": "Verbinden Sie Ihr Gerät",
      "connect": "verbinden",
      "disconnect": "trennen",
      "device": "Gerät",
      "phone": "Telefon",
      "checking_device": "Gerät wird überprüft",
      "not_supported_wa_message": "nicht unterstützte WhatsApp-Nachricht"
    }
  },
  "DASHBOARDS": {
    "flights": "Fahrten",
    "no_flights": "keine Fahrten",
    "upcoming": "bevorstehend",
    "historical": "beendet",
    "this_month": "dieser Monat",
    "bookings": "offene Buchungen",
    "vouchers": "Voucher",
    "open": "offen",
    "completed": "abgeschlossen",
    "expired": "abgelaufen",
    "idea_voting": "Ideenwahl",
    "search": "Suche",
    "payments": "Zahlungen",
    "charts": "Berichte",
    "flights_of_today_and_tomorrow_morning": "alle Fahrten von heute und morgen früh",
    "flights_of_next_7_days": "alle Fahrten der nächtsten 7 Tagen",
    "bookings_to_confirm_bookmarked_and_of_today_or_tomorrow_morning": "alle zu bestätigenden, für heute oder morgen früh gebuchten Buchungen, die neue Reservierungen oder mit ein dashboard-tag",
    "basic_charts_of_reservations_and_flights": "grafische Darstellungen von Buchungen und Fahrten",
    "charts_are_no_longer_shown_on_the_dashboard_please_navigate_to_reports": "grafische Berichte werden nicht mehr auf dem Dashboard angezeigt, bitte navigieren Sie zu den Berichten",
    "navigate_to_reports": "Zu den Berichten wechseln",
    "most_recent_sms_per_contact": "neueste Konversationen",
    "messages_bookings": "Nachrichten Buchungen",
    "messages_crew": "Nachrichten Crew",
    "messages": "Nachrichten",
    "sms_bookings": "SMS Buchungen",
    "sms_crew": "SMS Crew",
    "show_all_messages": "alle",
    "show_messags_from_this_flight": "nur diese Fahrt anzeigen",
    "show_messages_from_this_booking": "nur diese Buchung anzeigen",
    "show_unread": "ungelesene"
  },
  "FLIGHTS": {
    "LIST_FILTER": {
    	"upcoming": "anstehend",
    	"upcoming_desc": "noch zu fahren oder aus den letzten 7 Tagen",
    	"older": "nicht abgeschlossen (älter)",
    	"older_desc": "vor mehr als 7 Tagen geplante Fahrten, noch nicht abgeschlossen",
    	"historical": "beendet",
    	"historical_desc": "gefahren oder storniert"
    },
    "show_expired_on_flight_date": "abgelaufene am Fahrtdatum anzeigen ({{n}})",
    "BULK": {
      "selected": "{{count}} ausgewählt (max. {{limit}})",
      "clear_selection": "Auswahl aufheben",
      "select_all_matching": "Alle gefilterten Fahrten auswählen",
      "actions": "Sammelaktion",
      "choose_action": "Aktion wählen",
      "deselect_all": "Alle abwählen",
      "make_public": "Öffentlich machen",
      "make_private": "Privat machen",
      "download_csv": "CSV herunterladen",
      "ACTION": {
        "SET_VISIBILITY_PUB": "Fahrten öffentlich machen",
        "SET_VISIBILITY_PRI": "Fahrten privat machen",
        "ADD_TAG": "Tag hinzufügen",
        "REMOVE_TAG": "Tag entfernen",
        "CANCEL": "Fahrten absagen",
        "DELETE": "Fahrten löschen"
      },
      "recent_actions": "Sammelaktionen der letzten 24 Stunden",
      "no_recent_actions": "Keine Sammelaktionen in den letzten 24 Stunden",
      "undone": "rückgängig gemacht",
      "undone_by": "Rückgängig gemacht von {{user}}",
      "too_many_matches": "{{total}} Fahrten entsprechen diesem Filter. Eine Sammelaktion kann höchstens {{limit}} Fahrten gleichzeitig ändern. Schränken Sie Suche, Zeitraum oder Tag-Filter ein, zum Beispiel monatsweise.",
      "limit_reached": "Sie können höchstens {{limit}} Fahrten für eine Sammelaktion auswählen. Schränken Sie Suche, Zeitraum oder Tag-Filter ein.",
      "no_matches": "Keine Fahrten entsprechen diesem Filter.",
      "confirm_selected": "{{count}} Fahrten ausgewählt.",
      "date_range": "Zeitraum",
      "will_update": "{{count}} werden geändert",
      "will_stay_unchanged": "{{count}} haben diese Einstellung bereits",
      "will_skip": "{{count}} werden übersprungen",
      "undo_hint": "Sie können diese Aktion innerhalb von 24 Stunden einmal rückgängig machen.",
      "apply": "Auf {{count}} Fahrten anwenden",
      "updated": "{{count}} geändert",
      "unchanged": "{{count}} unverändert",
      "skipped": "{{count}} übersprungen",
      "restored": "{{count}} wiederhergestellt",
      "not_restored": "{{count}} nicht wiederhergestellt",
      "undo": "Rückgängig machen",
      "undo_available_until": "Rückgängig machen möglich bis",
      "SKIP": {
        "NOT_FOUND": "Fahrt existiert nicht mehr",
        "NOT_UPCOMING": "Fahrt ist abgesagt oder abgeschlossen",
        "HAS_BOOKINGS_FUTURE": "hat Buchungen: einzeln absagen, damit die Passagiere informiert werden",
        "HAS_BOOKINGS": "hat Buchungen",
        "NOT_SCHEDULED": "nur geplante Fahrten können gelöscht werden",
        "ERROR": "unerwarteter Fehler"
      },
      "UNDO_SKIP": {
        "CHANGED_SINCE": "seitdem geändert, nicht wiederhergestellt",
        "NOT_FOUND": "Fahrt existiert nicht mehr",
        "DELETED": "Buchung gelöscht",
        "ON_OTHER_FLIGHT": "Buchung auf einer anderen Fahrt geplant",
        "NOT_OPEN": "Buchung nicht mehr offen",
        "ERROR": "unerwarteter Fehler"
      }
    },
    "CANCEL": {
      "title": "Fahrt absagen",
      "reason_from_message": "Grund: {{reason}}",
      "change_reason": "ändern",
      "cancel_and_send": "absagen und Nachricht senden",
      "cancel_and_send_crew": "absagen und Nachricht senden + Crew",
      "cancel_only": "nur absagen",
      "cancel_only_warning": "die Passagiere werden nicht benachrichtigt",
      "confirm": "bestätigen",
      "already_sent": "Absagenachricht bereits gesendet",
      "send_failed": "die Nachricht konnte nicht gesendet werden — die Fahrt wurde nicht abgesagt",
      "back": "zurück"
    },
    "cancel_message_only": "nur Absagenachricht senden",
    "cancel_message_sent_chip": "Absagenachricht gesendet — Fahrt noch nicht abgesagt",
    "passengers_not_notified": "Passagiere wurden nicht benachrichtigt",
    "CHECKIN_LOG": {
    	"title": "Piloten-Check-in",
    	"empty": "keine Änderungen während des mobilen Check-ins",
    	"signoff_cleared": "Pilotenunterschrift gelöscht",
    	"signoff_signed": "Pilot hat unterschrieben"
    },
    "cancelled_bookings": {
      "title": "Passagiere bei Stornierung",
      "send_message": "Stornierungsnachricht senden",
      "restore": "Fahrt wiederherstellen",
      "restore_confirm": "Die Fahrt wird wiederhergestellt und die Passagiere, die darauf waren, werden wieder hinzugefügt. Buchungen, die inzwischen auf einer anderen Fahrt sind, bleiben unverändert.",
      "restore_done": "Fahrt wiederhergestellt, {{count}} Buchung(en) wieder hinzugefügt.",
      "restore_skipped": "Nicht wiederhergestellt: {{skipped}}.",
      "skip_DELETED": "Buchung existiert nicht mehr",
      "skip_ON_OTHER_FLIGHT": "inzwischen auf einer anderen Fahrt",
      "skip_NOT_OPEN": "Buchung ist nicht mehr offen"
    },
    "save": "speichern",
    "reset": "zurücksetzen",
    "unknown": "unbekannt",
    "CON": "bestätigt",
    "invited_by_sms": "per SMS eingeladen",
    "DEC": "abgelehnt ",
    "MOR": "Morgen",
    "EVE": "Abend",
    "CPF": "gewerbliche private Fahrt",
    "COF": "gewerbliche Fahrt",
    "NCF": "nicht-gewerbliche Fahrt",
    "PRI": "nicht veröffentlicht",
    "PUB": "veröffentlicht",
    "SCH": "geplant",
    "REA": "fertig",
    "MARK": {
      "SCH": "Planungsstatus",
      "REA": "Ready",
      "CAN": "Fahrt abbrechen",
      "FIN": "Fahrt abschließen"
    },
    "INFO": {
      "SCH": "Packen Sie Ihre Sachen zusammen und machen Sie sich bereit für die Ballonfahrt",
      "REA": "gut gemacht! Diese Fahrt ist bereit zur Freigabe",
      "CAN": "diese Fahrt ist annulliert, Sie können sie aus dem System entfernen",
      "FIN": "diese Fahrt ist abgeschlossen, großartige Arbeit!"
    },
    "checkin": "einchecken",
    "CAN": "annulliert",
    "FIN": "beendet",
    "balloon": "Ballone",
    "date": "Datum",
    "period": "Zeitraum",
    "event": "Event",
    "hour": "Zeit",
    "hourMeeting": "Treffzeit",
    "sunrise": "Sonnenaufgang",
    "sunset": "Sonnenuntergang",
    "flight_type": "Fahrttyp",
    "location": "Standort ",
    "visibility": "Sichtbarkeit",
    "web": "Web",
    "status": "Status",
    "comment": "Kommentar",
    "crew_comments": "Crew-Kommentare",
    "pilot": "Pilot ",
    "pilot_status": "Status",
    "action_needed": "Aktion erforderlich",
    "ground_crew": "Crew ",
    "pilot_and_crew": "Pilot und Crew",
    "not_enough_data": "nicht genügend Daten",
    "answer_pilot_yes_no": "Mit PILOT JA oder PILOT NEIN antworten.",
    "pilot_yes": "PILOT JA",
    "pilot_no": "PILOT NEIN",
    "Flight date cannot be set in the past": "Fahrtdatum kann nicht in die Vergangenheit gelegt werden",
    "answer_crew_yes_no": "Mit BESATZUNG JA oder BESATZUNG NEIN antworten.",
    "crew_yes": "BESATZUNG JA",
    "crew_no": "BESATZUNG NEIN",
    "flights": "Fahrten",
    "flight_bookings": "Fahrtbuchungen",
    "UNK": "hinzugefügt",
    "INV": "per SMS eingeladen",
    "invite_all": "SMS alle einladen",
    "inviteCount": "lädt ein",
    "invite_count_1": "einladen",
    "mo": "Mo",
    "tu": "Di",
    "we": "Mi",
    "th": "Do",
    "fr": "Fr",
    "sa": "Sa",
    "su": "So",
    "invite": "SMS versenden",
    "mail": "E-Mail",
    "reply": "Geben Sie hier Ihre Nachricht ein",
    "sms": "sms",
    "whatsapp": "WhatsApp",
    "whatsapp_sms": "WhatsApp (backup sms)",
    "message": "Nachricht",
    "message_whatsapp": "WhatsApp Nachricht",
    "message_sms_fallback": "SMS Fallback Nachricht",
    "confirm": "bestätigen",
    "remove": "entfernen",
    "contactName": "Kontaktname",
    "bookingType": "Buchungsart",
    "region": "Region",
    "passengers": "Passagiere",
    "no_bookings_selected": "keine Buchungen ausgewählt",
    "matching_bookings": "Buchungen",
    "mismatching_bookings": "Buchungen mit Fahrten",
    "mismatchReasons": "Fahrt-Matching",
    "add_all": "alle hinzufügen",
    "add": "hinzufügen",
    "add_and_confirm": "hinzufügen + bestätigen",
    "already_added": "bereits hinzugefügt",
    "messages": "Nachrichten",
    "calendar": "Kalender",
    "download_manifest": "Durchführungsplan herunterladen",
    "send_sms_reminder": "SMS-Erinnerung senden",
    "update": "Update",
    "are_you_sure": "sind Sie sicher?",
    "reminder_sms_will_be_sent": "es wird eine Erinnerungs-SMS verschickt",
    "edit_sms": "SMS verfassen",
    "edit_wa": "WhatsApp verfassen",
    "preview_sms": "Vorschau",
    "send": "senden",
    "send_to_pax": "an PAX senden",
    "send_to_pax_and_crew": "an PAX und CREW senden",
    "send_up_url_with_sms": "UP-URL mit SMS senden",
    "send_up_url_with_msg": "UP-URL mit MSG senden",
    "upTitle": "Mit diesem Link geht es direkt zu deiner persönlichen Buchungsseite!\n[persönlicher Link wird gesendet]",
    "flightOptions": "Flugoptionen",
    "flightOptionsTitle": "Sehr gerne laden wir Sie ein, an einem der folgenden Termine mitzufahren:\n[persönliche Liste der Flüge mit ausreichend Plätzen wird gesendet]",
    "send_flightoptions_with_msg": "Flugoptionen mit MSG senden",
    "sent": "gesendet",
    "message_has_been_sent": "Nachricht wurde gesendet",
    "message_has_not_been_sent": "Nachricht wurde nicht gesendet",
    "not_sent": "nicht gesendet",
    "not_confirmed_bookings_will_be_removed_from_flight": "die folgenden, nicht bestätigten Buchungen werden aus dem Fahrtplan gestrichen",
    "flight_will_be_cancelled": "die Fahrt wird annulliert",
    "flight_will_be_finished": "die Fahrt wird beendet",
    "flight_will_be_reopened": "die Fahrt geht zurück zur Planung",
    "yes_cancel_it": "ja, Fahrt absagen",
    "no_please": "nein, bitte nicht absagen",
    "cancel_sms_will_be_sent": "Absage-SMS wird gesendet",
    "not_cancelled": "nicht abgesagt",
    "flight_has_not_been_cancelled": "die Fahrt wurde nicht abgesagt",
    "confirm_message": "sind Sie sicher, dass Sie diese Fahrt absagen wollen?",
    "flight_pilot_in_command": "verantwortlicher Pilot",
    "invite_by_sms": "SMS versenden",
    "unsupported_phonenumber": "nicht unterstützte Rufnummer",
    "sms_unclear": "SMS unklar",
    "no_pilot_in_command_selected": "kein verantwortlicher Pilot ausgewählt",
    "flight_crew": "Crew",
    "no_crew_selected": "keine Crew ausgewählt",
    "available_pilots_and_crew": "verfügbare Piloten und Crew",
    "select_pilot": "Pilot auswählen",
    "select_crew": "Crew auswählen",
    "other_flight": "andere Fahrt",
    "add_as_crew": "als Crew hinzufügen",
    "add_as_pilot": "als Pilot hinzufügen",
    "warning": "Warnung",
    "creating_a_flight_can_lead_to_costs": "diese Maßnahme kann Kosten verursachen",
    "proceed": "fortfahren",
    "cancel": "abbrechen",
    "passenger_count": "Anzahl Passagiere",
    "crew_count": "Anzahl Crewmitglieder",
    "type": "Typ",
    "no_pilot": "kein Pilot",
    "seats": "Sitze ",
    "delete": "löschen",
    "set_ready": "fertig",
    "address": "Adresse",
    "postalCode": "ZIP",
    "city": "Stadt",
    "country": "Land",
    "manifest": "Fahrtdurchführungsplan",
    "certificates": "Zertifikate",
    "takeoffTime": "Abfahrtzeit",
    "landingLocation": "Landeort",
    "landingDetails": "Details zur Landung",
    "total_weight": "Gesamtgewicht",
    "landingTime": "Landezeit",
    "flightTime": "Fahrtzeit",
    "and": "und",
    "name": "Name",
    "ref": "Ref.",
    "amount": "Betrag (EUR)",
    "weight": "Gewicht",
    "signature": "Unterschrift",
    "reminder_sms": "Erinnerungs-SMS",
    "also_to_pilot_and_crew": "ebenso an Pilot und Crew",
    "cancel_sms": "SMS annullieren",
    "no_flights_found": "keine Fahrten gefunden",
    "no_location": "kein Standort",
    "show": "zeigen",
    "hide": "ausblenden",
    "lift": "Tragkraft",
    "lift_needed": "erforderliche Tragkraft",
    "lift_available": "verfügbare Tragkraft",
    "lift_spare": "verbleibende Tragkraft",
    "lift_level_green": "Tragkraftreserve OK",
    "lift_level_orange": "Tragkraftreserve niedrig",
    "lift_level_red": "Tragkraftreserve zu niedrig",
    "lift_level_blue": "unterbeladen — Landung unter Mindestlandemasse (MLM) möglich",
    "lift_level_unknown": "Liftdaten unvollständig",
    "takeoff_location": "Startort",
    "temp": "Temperatur",
    "takeoff_height": "Startplatzhöhe",
    "maximum_height": "maximale Höhe",
    "temp_takeoff": "Starttemperatur",
    "temp_takeoff_manual_hint": "manuell eingegeben — klicken, um wieder die Meteoblue-Temperatur zu verwenden",
    "temp_max": "Maximalhöhe Temperatur",
    "weather_qfe": "Startdruck (QNH)",
    "weather_pmax": "Maximalhöhe Druck",
    "balloon_volume": "Hüllenvolumen",
    "balloon_temp": "Maximale Temperatur Hülle",
    "create_add": "zur neuen Fahrt hinzufügen",
    "weather": "Wetter",
    "copy_weather_to": "Wetter kopieren zu",
    "use_meteoblue": "Meteoblue verwenden",
    "skeyes_ballooning_bulletin": "skeyes ballooning bulletin",
    "use_skeyes": "Skeyes verwenden",
    "weather_forecast": "Wettervorhersage",
    "no_weather_forecast": "keine Wettervorhersage verfügbar",
    "windSummary": "Zusammenfassung der Wettervorhersage",
    "weather_source": "Quelle",
    "weather_source_forced": "offizielle Quelle (Wettereinstellungen)",
    "weather_forecast_date": "Datum der Wettervorhersage",
    "vfr_visual": "Sichtbarkeit",
    "vfr_clouds": "Wolken",
    "wind_gl": "Wind Bodenhöhe",
    "wind_gl_short": "Wind GL",
    "wind_dir": "Richtung",
    "wind_gl_direction": "Windrichtung Bodenhöhe",
    "wind_10": "Wind 1000FT",
    "wind_10_direction": "Windrichtung 1000FT",
    "wind_20": "Wind 2000FT",
    "wind_20_direction": "Windrichtung 2000FT",
    "wind": "Wind",
    "clear": "klar",
    "fuel_spare": "Treibstoffreserve",
    "planned_flight_time": "geplante Fahrtzeit",
    "spare_flight_time": "reserve Fahrtzeit",
    "maximum_flight_time": "verfügbare Fahrtzeit",
    "select_balloon": "den Ballon auswählen",
    "select_location": "den Standort auswählen",
    "offsets": "Sonnenaufgang-/Sonnenuntergang-Offsets ändern",
    "flight_hour_will_be_calculated_based_on_sunset_minus_the_offset_minutes": "Die Stunde der Fahrt wird auf der Grundlage des Sonnenuntergangs (oder Sonnenaufgangs) abzüglich der Offset-Minuten berechnet, abgerundet auf eine halbe Stunde. Negative Werte sind zulässig (im Falle des Sonnenaufgangs).",
    "offset_sunrise": "Offset-Sonnenaufgang (Minuten)",
    "offset_sunset": "Offset-Sonnenuntergang (Minuten)",
    "payment_overview": "Zahlungsübersicht",
    "go_back": "geh zurück",
    "freeSpots": "Freie Plätze",
    "traject": {
      "trajectory": "Trajektorie",
      "custom_flight_profile": "benutzerdefiniertes Fahrtprofil",
      "duration": "Dauer",
      "duration_is_required": "Dauer ist erforderlich",
      "level": "Höhe",
      "level_is_required": "Höhe ist erforderlich",
      "save": "speichern",
      "no_trajectory_without_meteo": "keine Trajektorie ohne Wettervorhersage",
      "update_custom_profile": "benutzerdefiniertes Profil aktualisieren",
      "refresh_weather": "Wetter aktualisieren",
      "talking_to_meteoblue": "mit meteoblue sprechen",
      "refresh_hint": "Meteoblue aktualisiert sein Wettermodell regelmäßig. Eine erneute Aktualisierung ist 4 Stunden nach der letzten Aktualisierung wieder möglich."
    },
    "LANDING": {
      "landing": "Landung",
      "landing_details": "details",
      "map": "map",
      "no_details": "keine Details verfügbar",
      "landing_data": "Landedaten können vorerst nur im mobilen Check-in-Bildschirm geändert werden",
      "refuelVolume": "Getankte Gasmenge",
      "update_log": "Log ändern",
      "update_log_hint": "Hier können Sie nur die Landedaten ändern. Öffnen Sie den Flug, um alle anderen Flugdaten zu ändern.",
      "open_flight": "Flug öffnen"
    },
    "FILTER": {
      "date_range_filter": "Datumsbereichsfilter",
      "from": "von",
      "till": "bis",
      "excluded": "ausgeschlossen",
      "no_date_filter_active": "kein aktiver Datumsfilter",
      "enter_a_date_range": "Geben Sie einen Datumsbereich ein",
      "start_date": "Startdatum",
      "end_date": "Enddatum",
      "month": "Monat",
      "week": "Woche",
      "day": "Tag",
      "flights": "Fahrten"
    },
    "flight_no_bookings": "Diese Fahrt hat noch keine Buchungen",
    "mor_flight": "Morgenfahrt",
    "eve_flight": "Abendfahrt",
    "mor_flights": "Morgenfahrten",
    "eve_flights": "Abendfahrten",
    "no_mor_flights": "keine Morgenfahrten",
    "no_eve_flights": "keine Abendfahrten",
    "responded_pilots": "Piloten mit Rückmeldung",
    "delete_flight": "Fahrt löschen",
    "toggle_visibility": "Sichtbarkeit ändern",
    "tags": "tags",
    "COPY": {
      "copy_flight": "Fahrt kopieren",
      "select_multiple_dates": "Wählen Sie mehrere Daten aus, um die Fahrt mit demselben Standort, Ballon, Piloten und Crew zu kopieren",
      "selected_dates": "ausgewählte Daten",
      "no_tags": "keine Tags",
      "copy": "kopieren"
    },
    "PILOTANDCREW": {
      "selected": "ausgewählt",
      "most_used": "am häufigsten verwendet",
      "this_is_the_most_used_pilot_and_crew": "dies ist der am häufigsten verwendete Pilot und die Crew für diesen Ballon",
      "accept": "akzeptieren",
      "all_pilots_and_crew": "alle Piloten und Crew",
      "select": "auswählen"
    },
    "FREESPOTS": {
      "showAll": "Alle Flüge anzeigen",
      "showOverbookings": "Überbuchungen anzeigen",
      "freeSpots": "Alle Flüge mit {{count}} oder mehr freien Plätzen anzeigen",
      "showMore": "Weitere Optionen anzeigen"
    },
    "selected_flight": "Ausgewählte Fahrt",
    "selected_flight_hint": "Diese Buchung ist derzeit für diese Fahrt geplant",
    "possible_flights": "Kommende Fahrten",
    "possible_flights_hint": "Dies sind die kommenden Fahrten, für die diese Buchung geplant werden kann, unter Berücksichtigung freier Plätze und Tag-Beschränkungen",
    "balloon_cannot_accept_passengers": "Ballon kann keine Passagiere aufnehmen",
    "balloon_in_use_tooltip": "Der Ballon wird auf einem anderen Flug mit Passagieren verwendet. Wechseln Sie zu einem anderen Ballon, um hier Passagiere hinzuzufügen.",
    "reduce_capacity_by_one_pax": "Kapazität um einen Passagier reduzieren",
    "reset_capacity": "Kapazität zurücksetzen",
    "has_open_amount_tooltip": "Bei diesem Flug sind noch Beträge offen"
  },
  "DISPLAYEDCOLUMNS": {
    "hint": "Wählen Sie Spalten aus und ändern Sie die Reihenfolge per Drag & Drop nach Ihren Wünschen",
    "warning": "Achtung, Sie müssen Ihre Einstellungen nach Änderungen an den Spaltendefinitionen zurücksetzen",
    "flightsUpcoming": "Spalten für bevorstehende Flüge",
    "flightsBooking": "Spalten für Flüge aus Buchungen",
    "flightsHistory": "Spalten für historische Flüge",
    "bookingsOpen": "Spalten für offene Buchungen",
    "bookingsHistory": "Spalten für historische Buchungen",
    "bookingsPayment": "Spalten für Zahlungsnachverfolgung",
    "bookingsDashboard": "Spalten für Buchungs-Dashboard",
    "bookingsFlight": "Spalten für Buchungen auf einem Flug",
    "bookingsFlightEnd": "Spalten für Buchungen auf beendetem Flug",
    "bookingsFlightCancelled": "Spalten für Buchungen eines stornierten Flugs",
    "bookingsFlightAll": "Spalten für Buchungen auf einem Flug",
    "bookingsFlightPayment": "Spalten für Zahlungsnachverfolgung",
    "status": "Status",
    "name": "Ballon",
    "nameBadge": "Ballon",
    "date": "Datum",
    "event": "Ereignis",
    "hour": "Uhrzeit",
    "location": "Ort",
    "pilot": "Pilot",
    "crew": "Crew",
    "bookings": "Buchungen",
    "comments": "Bemerkungen",
    "passengers": "Passagiere",
    "passengersWeight": "Gewicht",
    "action": "Aktion",
    "bookingDate": "Buchungsdatum",
    "contactName": "Kontaktname",
    "phone": "Telefon",
    "region": "Region",
    "city": "Stadt",
    "preferredDate": "Verfügbarkeit",
    "flightDate": "Flugdatum",
    "flightPeriod": "Flugperiode",
    "flight_balloon": "Flugballon",
    "flight_location": "Flugort",
    "flight_pilot": "Flugpilot",
    "totalAmount": "Gesamtbetrag",
    "paid_amount": "bezahlt",
    "openAmount": "Saldo",
    "flight_confirmation": "Flug bestätigen",
    "messages": "Nachrichten",
    "up": "UP",
    "contactCard": "Buchung",
    "passengersCard": "Passagiere",
    "mismatchReasons": "Flugabgleich",
    "mobile_view": "auf Mobilgerät sichtbar"
  },
  "MANIFEST": {
    "fuel_consumption": "Treibstoffverbrauch",
    "fuel_needed": "benötigter Treibstoff",
    "fuel_available": "verfügbarer Treibstoff ",
    "load_chart_and_passenger_list": "Tragkraftberechnung und Passagierliste",
    "passenger_list": "Passagierliste",
    "weather_conditions": "Wetterbedingungen",
    "fuel_calculations": "Treibstoffberechnung",
    "load_chart": "Tragkraftberechnung",
    "after_flight": "Nach der Fahrt",
    "visible_defects": "Sichtbare Defekte",
    "yes_no": "Ja/Nein",
    "date": "Datum",
    "signature": "Unterschrift",
    "defect": "Defekt",
    "action": "Aktion",
    "certificate": "Zertifikat",
    "authority": "Behörde",
    "initials": "Initialen",
    "confirmation": "Damit wird bestätigt, dass die angegebenen Aktionen gemäß PART-ML ausgeführt wurden und das Luftfahrzeug für die nächsten Fahrt freigegeben wurde."
  },
  "LOCATIONS": {
    "name": "Name",
    "description": "Beschreibung",
    "region": "Region",
    "address": "Adresse",
    "postalCode": "Postleitzahl",
    "city": "Stadt",
    "country": "Land",
    "height": "Startplatzhöhe",
    "maximum height": "maximale Höhe",
    "locations": "Standorte",
    "confirm_message": "Sind Sie sicher, dass Sie löschen wollen?",
    "confirm": "bestätigen",
    "update": "Update",
    "delete": "löschen",
    "regions": "Regionen",
    "save": "speichern",
    "add_location": "Standort hinzufügen",
    "add_region": "Region hinzufügen",
    "hot_airfield": "Flugplatz",
    "coordinates": "Koordinaten",
    "geolocate": "geolokalisieren",
    "no_results": "keine Ergebnisse",
    "contact": "Kontakt",
    "takeoff_location": "Standort",
    "takeoff_location_subtitle": "Die Koordinaten des Startortes werden für die Wettervorhersage, die Trajektorie und die Auftriebsberechnung verwendet.",
    "meetingpoint": "Treffpunkt",
    "meetingpoint_subtitle": "Die Adresse des Treffpunktes wird den Passagieren (UP) mitgeteilt.",
    "same_as_takeoff": "gleich wie Startort",
    "meetingpointAddress": "Treffpunkt Adresse",
    "search_address": "Adresse suchen",
    "CONTACT": {
      "name": "Name",
      "type": "Typ",
      "comment": "Kommentar",
      "phone": "Telefon",
      "email": "Email",
      "when_to_contact": "wann zu kontaktieren",
      "how_to_contact": "wie zu kontaktieren",
      "NOMSG": "person wird nicht kontaktiert",
      "MAIL": "email",
      "SMS": "msg",
      "mail": "wenn die Fahrt vorbereitet wird, wird die Kontaktperson eine email erhalten",
      "sms": "wenn die Fahrt vorbereitet wird, wird die Kontaktperson eine msg erhalten",
      "no_message": "die Kontaktperson wird nicht kontaktiert",
      "add_sms_template": "msg template hinzufügen",
      "add_mail_template": "email template hinzufügen",
      "mail_template": "email template",
      "sms_template": "msg template",
      "warning_email": "sie haben noch keine email an die kontaktperson gesendet",
      "warning_sms": "sie haben noch keine sms an die kontaktperson gesendet"
    }
  },
  "FLYABILITY": {
    "verdict_good": "gut zum Fliegen",
    "verdict_marginal": "fraglich",
    "verdict_nogo": "voraussichtlich nicht fliegbar",
    "no_assessment": "keine Bewertung verfügbar",
    "all_within_limits": "alle Parameter innerhalb deiner Grenzwerte",
    "unknown_excluded": "keine Daten für {{parameters}} — nicht berücksichtigt",
    "advisory": "Diese Einschätzung ist nur eine Hilfe auf Basis deiner eigenen Grenzwerte — der verantwortliche Pilot entscheidet.",
    "param_windGl": "Bodenwind",
    "param_wind500": "Wind auf 500 m",
    "param_gustSpread": "Böen über Bodenwind",
    "param_precipitation": "Niederschlag",
    "param_lowClouds": "tiefe Bewölkung",
    "param_visibility": "Sicht"
  },
  "FORECAST": {
    "no_mobile": "Meteo wird derzeit nur auf größeren Bildschirmen unterstützt",
    "select_favorite": "Wählen Sie einen Standort als Favoriten aus, um die meteoblue-Wettervorhersage anzuzeigen",
    "no_forecast": "Für diesen Standort ist kein Meteo verfügbar. Überprüfen Sie Breiten- und Längengrad",
    "remove_favorite": "Favorit entfernen",
    "mark_favorite": "Favorit markieren",
    "favorite_description": "Dieser Ort ist Ihr Lieblingsort. Die meteoblue Wettervorhersage ist auf dem Dashboard für diesen Standort verfügbar",
    "non_favorite_description": "Dieser Ort ist nicht Ihr Lieblingsort. Markieren Sie, dass es Ihr Favorit ist, um die meteoblue-Wettervorhersage auf dem Armaturenbrett anzuzeigen",
    "meteo": "meteo",
    "time": "time",
    "summary": "summary"
  },
  "REGIONS": {
    "name": "Name",
    "locations": "Standorte",
    "no_locations_yet": "noch keine Standorte",
    "name_required": "Name erforderlich",
    "change_color": "Klicken Sie hier, um die Regionsfarbe zu ändern",
    "reset_color": "farbe zurücksetzen",
    "confirm_color": "farbe bestätigen",
    "cancel_color": "farbe abbrechen",
    "openBookings": "Offene Reservierungen",
    "notusedyet": "noch keine Reservierungen",
    "move": "Alle Reservierungen in eine andere Region verschieben",
    "select_target_region": "Bitte wählen Sie die neue Region für sämtliche {0}-Reservierungen in dieser Region"
  },
  "EVENTS": {
    "new_event": "neues Event",
    "information": "ein Event an einem bestimmten Datum hinzufügen oder die Feiertage laden",
    "new_crew_event": "neuer Termin",
    "crew_information": "einen besetzten Termin hinzufügen (nicht verfügbar für Flüge oder Besatzung)",
    "holidays": "Ferien",
    "load_public_holidays_of_year_from_country": "Feiertage von {0} aus {1} laden",
    "date": "Datum",
    "description": "Beschreibung",
    "save": "speichern",
    "cancel": "abbrechen",
    "required": "obligatorisch",
    "crew": "Besatzung",
    "NO": "nicht verfügbar",
    "YES": "verfügbar",
    "MAYBE": "evtl. verfügbar",
    "UNK": "verfügbarkeit unbekannt",
    "comment_availability": "Worauf müssen wir achten",
    "comment": "Kommentar"
  },
  "SETTINGS": {
    "VARIANTS": {
      "duplicate": "duplizieren",
      "copySuffix": "(Kopie)",
      "reasonCode": "Absagegrund",
      "reasonCodeHint": "Wählst du diesen Grund beim Absagen, ist diese Nachricht vorausgewählt. Ein Grund gehört zu höchstens einer Nachricht.",
      "reasonGeneral": "— keiner (allgemeine Nachricht) —",
      "reasonTaken": "verwendet von {{label}}",
      "reasonRemoved": "(entfernter Grund)",
      "default": "Standard",
            "add": "Variante hinzufügen",
            "remove": "Variante entfernen",
            "label": "Name der Variante",
            "labelHint": "Optional — unterscheidet mehrere Texte desselben Nachrichtentyps (z. B. \"Morgenfahrt\", \"kurzfristig\").",
            "picker": "Textversion",
            "variant": "Variante",
            "waIssues": "WhatsApp Business kann diesen Text nicht einreichen",
            "waRejected": "Von Meta abgelehnt",
            "waResubmitHint": "Passen Sie den Text an und speichern Sie — er wird automatisch erneut zur Genehmigung bei Meta eingereicht.",
            "wabaColumn": "WhatsApp-Status",
            "ISSUES": {
                "VARIABLE_AT_START": "beginnt mit einer Variablen",
                "VARIABLE_AT_END": "endet mit einer Variablen",
                "ADJACENT_VARIABLES": "zwei Variablen direkt hintereinander",
                "TOO_MANY_VARIABLES": "zu viele Variablen für den festen Text",
                "UNKNOWN_PLACEHOLDER": "unbekannte Variable für diesen Nachrichtentyp",
                "TOO_LONG": "Text ist zu lang",
                "EMPTY_TEXT": "kein Text"
            }
        },
    "user_default_language": "Standardsprache des Benutzers",
    "submit": "einreichen",
    "preferences_language": "Sprache",
    "preferences_sms": "SMS",
    "smsTitle": "Titel",
    "smsTemplate": "Vorlage",
    "pilotInvitationSms": "Einladungs-SMS Pilot",
    "example": "Beispiel",
    "update": "Update",
    "crewInvitationSms": "Einladungs-SMS Crew",
    "passengerInvitationSms": "Einladungs-SMS Passagiere",
    "cancelSms": "Absage-SMS",
    "reminderSms": "Erinnerungs-SMS",
    "locationContactSms": "Standortkontakt-SMS",
    "checkinNotificationSms": "Check-in-Benachrichtigung SMS",
    "bookingConfirmationSms": "Reservierungsbestätigung SMS",
    "platformUpLink": "UP-Link (feste Vorlage)",
    "platformFlightOptions": "Fahrtvorschläge (feste Vorlage)",
    "emailTitle": "Titel",
    "no_emailTitle": "kein Titel",
    "emailType": "type",
    "emailTo": "email to",
    "emailAttachments": "Anlagen",
    "emailAttachments_save_hint": "vergessen Sie nicht, Ihre Vorlage nach dem Hinzufügen oder Entfernen von Anlagen zu speichern",
    "emailSubject": "Betreff",
    "emailBody": "Körper",
    "emailTest": "E-Mail-Test",
    "mailFromEmail": "E-mail-Antwort Adresse",
    "mailFromName": "E-Mail-Antwort an E-Mail",
    "mailReplyToEmail": "Email Reply To Email",
    "mailAccountantName": "E-Mail-Name des Buchhalters",
    "mailAccountantEmail": "E-Mail-Adresse des Buchhalters",
    "bookingConfirmEmail": "E-Mail-Bestätigung der Buchung",
    "bookingFlightCancelEmail": "E-Mail Ende der Fahrt",
    "bookingFlightConfirmEmail": "E-Mail Bestätigung der Fahrt",
    "crewFlightEmail": "E-Mail Fahrtdaten für die Crew",
    "crewOtpEmail": "E-Mail-Login für die Crew",
    "pilotFlightEmail": "E-Mail Fahrtdaten für den Piloten",
    "flight_email": "E-Mail Fahrtdaten",
    "locationContactEmail": "Standortkontakt-E-Mail",
    "checkinNotificationEmail": "E-Mail Check-in-Benachrichtigung",
    "flight_email_passengers": "E-Mail Passagiere",
    "flight_sms_passengers": "SMS Passagiere",
    "flight_msg_passengers": "MSG Passagiere",
    "load_default": "einen Standardtext laden",
    "passenger_categories": "Passagierkategorien",
    "category_name": "Name",
    "category_description": "Beschreibung",
    "category_child": "Kind",
    "category_price": "Preis",
    "category_default": "Standard",
    "delete": "löschen",
    "mobile_questions": "Fragen Fahrgäste (mobil)",
    "question": "Frage",
    "kind": "Art",
    "active": "aktiv",
    "title": "Titel",
    "description": "Beschreibung",
    "language": "Sprache",
    "texts": "Texte",
    "name": "Name",
    "address": "Adresse",
    "email": "E-Mail",
    "weight": "Gewicht",
    "luggage": "Gepäck",
    "child": "Kind",
    "accompany": "begleiten",
    "pay": "bezahlen",
    "signature": "Unterschrift",
    "optional": "optional",
    "mandatory": "obligatorisch",
    "order": "Bestellung",
    "titles": "Fragen",
    "descriptions": "Fragen Texte",
    "yes": "ja",
    "no": "nein",
    "nl": "niederländisch",
    "fr": "französisch",
    "en": "englisch",
    "de": "deutsch",
    "es": "spanisch",
    "id": "ID",
    "download_sample": "Beispiel herunterladen",
    "drag_and_drop_file_here": "drag and drop file here",
    "browse_for_file": "Nach Datei suchen",
    "operator_settings": "Bedienereinstellungen",
    "operator_backup_and_sync": "backup en sync",
    "operator_bookings": "reservierung einstellungen",
    "operator_flights": "fahrt einstellungen",
    "operator_crew": "crew einstellungen",
    "operator_myflight": "UP (Passengers App) einstellungen",
    "operator_weather_source": "Wetter- und NOTAM-Einstellungen",
    "flyability": {
      "enabled": "Flugtauglichkeit auf der Wetterkarte anzeigen",
      "disabled_hint": "Aus: Wetterkarte und Flugdetail sehen genau so aus wie heute, ohne Bewertungen und ohne Farben. Schalte es ein, um jeden Vorhersagezeitraum an den Grenzwerten unten zu messen.",
      "band_good": "gut",
      "band_marginal": "fraglich",
      "band_nogo": "nicht fliegen",
      "explain_windGl": "Mittlere Windgeschwindigkeit am Boden während des Flugfensters. Sie entscheidet, ob Aufrüsten, Start und Landung sicher möglich sind — an dieser Grenze scheitern die meisten Flüge.",
      "explain_wind500": "Windgeschwindigkeit in etwa 500 Metern Höhe, wo ein Ballon den größten Teil des Fluges verbringt. Sie bestimmt, wie schnell und wie weit du fliegst, und damit wie viel Landegebiet du brauchst.",
      "explain_gustSpread": "Um wie viel stärker die Böen sind als der gleichmäßige Bodenwind. Böen von 8 kt über einem ruhigen Wind von 5 kt bedeuten trotzdem plötzliches Zerren an der Hülle beim Aufrüsten und Landen — deshalb wird das getrennt vom Wind selbst bewertet.",
      "explain_precipitation": "Der stärkste Niederschlag, der im Flugfenster erwartet wird. Eine nasse Hülle ist schwer und muss hinterher getrocknet werden, deshalb lassen die meisten Betreiber den grünen Bereich bei null.",
      "explain_lowClouds": "Der Anteil des Himmels, der von Wolken unterhalb von etwa 2 km bedeckt ist. Viel tiefe Bewölkung bedeutet eine niedrige Wolkenuntergrenze und wenig Sicht auf den Boden: 0 % ist wolkenlos, 100 % ist komplett bedeckt.",
      "explain_visibility": "Wie weit du horizontal sehen kannst. Du brauchst es zum Navigieren, um anderen Verkehr zu erkennen und rechtzeitig ein Landefeld zu wählen. Das ist der einzige Parameter, bei dem mehr besser ist — die Grenzwerte zählen hier nach oben.",
      "title": "Grenzwerte für Flugtauglichkeit",
      "hint": "Die Wetterkarte färbt jeden Vorhersagezeitraum grün, orange oder rot anhand dieser Grenzwerte. Lass einen Parameter auf dem Standard, um dem Plattformwert weiter zu folgen.",
      "good_upto": "gut bis",
      "marginal_upto": "fraglich bis",
      "good_from": "gut ab",
      "marginal_from": "fraglich ab",
      "is_default": "Standard",
      "reset": "auf Standard zurücksetzen",
      "reset_all": "alles auf Standard zurücksetzen",
      "saved": "Grenzwerte für Flugtauglichkeit gespeichert",
      "error_required": "beide Werte sind erforderlich",
      "error_negative": "Werte können nicht negativ sein",
      "error_order": "der Grenzwert für gut kann nicht strenger sein als der für fraglich"
    },
    "weatherSource": {
        "title": "offizielle Wetterquelle pro Land",
        "hint": "Wenn aktiviert, wird die Wetterquelle auf dem Flug und dem Operational Flight Plan (OFP) automatisch mit der offiziellen Quelle für das Land des Startorts ausgefüllt, statt Freitext.",
        "mapped": "offizielle Wetterquelle pro Land erzwingen",
        "source": "Wetterquelle",
        "locations": "Standorte",
        "locationsWithoutCountry": "Standorte ohne Land (bitte Land eintragen)",
        "addCountry": "Land hinzufügen"
    },
    "export": "export",
    "you_can_activate_a_daily_backup": "Sie können einen täglichen Export in HTML an eine bestimmte E-Mail-Adresse senden. Sobald Sie den Export aktivieren, erhalten Sie sofort einen Export an die angegebene E-Mail-Adresse, dann jeden Tag gegen 4 Uhr morgens",
    "daily_backup": "täglicher Export",
    "backup_email": "E-Mail-Adresse",
    "only_update_when_inactive": "Sie können die E-Mail-Adresse nur ändern, wenn der Export inaktiv ist",
    "exported_files": "exportierte Dateien",
    "bookings": "alle offenen Buchungen",
    "flights": "alle geplanten Fahrten",
    "vouchers": "alle Gutscheine",
    "flights_bookings_passengers": "alle geplanten Flüge mit ihren Buchungen und Passagieren",
    "calendarUrl": "ICS-URL für den Kalender",
    "you_can_subscribe_to_all_flights_in_your_personal_calendar": "Sie können alle Flüge in Ihrem persönlichen Kalender abonnieren",
    "geticsurl": "ICS-URL generieren",
    "readthedocs": "Dokumentation lesen",
    "crew": {
      "title": "Crew",
      "shareBookings": "Die Crew kann die Details der Buchungen einer Fahrt im Dashboard sehen",
      "shareBookingsHint": "Wenn dies nicht aktiviert wird, kann die Crew nur die Anzahl der Passagiere auf einer Fahrt im Dashboard sehen",
      "allowFlightSelection": "Crew kann Fahrten im Kalender auswählen",
      "allowFlightSelectionHint": "Wenn dies nicht angekreuzt ist, kann die Crew die Fahrten nur im Kalender sehen, aber nicht auswählen",
      "shareEvents": "Kalendertermine mit Crew teilen",
      "shareEventsHint": "wenn aktiviert, werden Operator-Termine (z.B. Feiertage, Firmenevents) für die Crew im Kalender sichtbar",
      "shareFlightTags": "Flug-Tags mit Crew teilen",
      "shareFlightTagsHint": "wenn aktiviert, werden Flug-Tags für die Crew im Kalender sichtbar",
      "crewReady": {
        "title": "Crew-Ready-Benachrichtigung",
        "channel": "Benachrichtigungskanal",
        "channelNone": "keine (deaktiviert)",
        "channelEmail": "E-Mail",
        "channelWhatsApp": "WhatsApp",
        "channelBoth": "Beide (E-Mail + WhatsApp)",
        "instructions": "Crew-Anweisungen",
        "includePassengers": "Passagiere in Benachrichtigung aufnehmen",
        "includeTrajectory": "Trajektoriebild in Benachrichtigung aufnehmen",
        "language": "Benachrichtigungssprache",
        "hint": "Die Crew wird automatisch per WhatsApp oder E-Mail informiert, wenn der Flugstatus auf bereit wechselt. Die Benachrichtigung enthält Flugdetails und optional Passagiere und Trajektorie.",
        "preview": "Vorschau"
      }
    },
    "operator_notifications": "Benachrichtigungen",
    "notifications": {
      "title": "E-Mail-Benachrichtigungen",
      "title_calendar": "E-Mail-Benachrichtigung über Verfügbarkeitsänderung",
      "title_flightCrew": "E-Mail-Benachrichtigung über Änderung des Piloten und/oder der Crew einer Fahrt",
      "calendar": "Erhalten Sie eine E-Mail, wenn sich die Verfügbarkeit von Crew und Piloten ändert",
      "calendarHint": "wenn dies aktiviert ist, sendet das System automatisch eine übersichtliche E-Mail an den Betreiber und die Crew 5 Minuten, nachdem die Crew oder der Pilot eine oder mehrere Verfügbarkeiten geändert hat",
      "calendarClosing": "E-Mail-Abschlusstext",
      "calendarClosingHint": "Dieser Abschlusstext wird jeder E-Mail hinzugefügt",
      "flightCrew": "Senden Sie eine E-Mail, wenn Sie einen Piloten oder ein Crewmitglied zu einer Fahrt hinzufügen",
      "flightCrewHint": "wenn dies aktiviert ist, wird automatisch eine E-Mail an den Piloten und die Crew gesendet, wenn Sie sie zu einer Fahrt hinzufügen oder entfernen",
      "save": "speichern"
    },
    "booking": {
      "title": "Buchung",
      "childAge": "Kinderalter",
      "childAgeHint": "Jeder Passagier mit diesem Alter oder jünger wird automatisch als Kind gekennzeichnet",
      "disabledPaymentTypes": "deaktivierte Zahlungsarten",
      "disabledPaymentTypesHint": "Wenn Sie eine Zahlungsart deaktivieren, wird sie nicht mehr auf der Buchungsseite angezeigt.",
      "none_of_the_paymentTypes_are_disabled": "keine der Zahlungsarten ist deaktiviert",
      "disabledPaymentTypesSave": "Zahlungsarten speichern",
      "sources": "Quellen",
      "flightOptionsCount": "Anzahl der Fahrtoptionen",
      "flightOptionsCountHint": "Die Anzahl der bevorstehenden Ballonfahrten, die für die Reservierung geeignet sind, unter Berücksichtigung der Passagierzahl und eventueller Einschränkungen (Tags)."
    },
    "flight": {
      "title": "Fahrten",
      "sunriseOffset": "Sonnenaufgang Offset",
      "sunriseOffsetHint": "Die Fahrtzeit wird auf Basis des Sonnenaufgangs minus der Anzahl der Offset-Minuten berechnet, abgerundet auf die untere halbe Stunde.",
      "sunsetOffset": "Sonnenuntergang Offset",
      "sunsetOffsetHint": "Die Fahrtzeit wird auf Basis des Sonnenuntergangs minus der Anzahl der Offset-Minuten berechnet, abgerundet auf die untere halbe Stunde.",
      "meetingTimeOffset": "Treffpunktzeit Offset",
      "meetingTimeOffsetHint": "Die Treffpunktzeit für die Fahrt wird auf Basis der Fahrtzeit minus der Anzahl der Offset-Minuten berechnet. Wenn 0, wird die Treffpunktzeit nicht angezeigt.",
      "sunrise": "Sonnenaufgang",
      "sunset": "Sonnenuntergang",
      "hourMeeting": "Treffzeit",
      "hour": "Startzeit",
      "save": "Offsets speichern",
      "save_hint": "Neue Offsets gelten nur für Fahrten, die ab jetzt erstellt werden",
      "save_and_update_hours": "Offsets speichern und Fahrten aktualisieren",
      "save_and_update_hours_hint": "alle kommenden Fahrten werden mit den neuen Offsets aktualisiert",
      "cancelReason": "Abbruchgrund",
      "cancelReasons": "Abbruchgründe",
      "cancelReasonsHint": "Wenn Sie einen Abbruchgrund auswählen, wird dieser in der Buchungsübersicht angezeigt",
      "cancelReasons_list_empty": "keine Abbruchgrund gefunden, fügen Sie Ihre ersten Abbruchgrund hinzu",
      "new_cancelreason": "neuer Abbruchgrund",
      "you_can_manage_all_cancelreasons_in_settings": "Sie können alle Abbruchgründe in den Einstellungen verwalten",
      "cancelreason_validation": "Abbruchgrund ist verpflichtend, min 3, max 50 Zeichen und muss eindeutig sein",
      "defaultPeriod": "Standard-Periode",
      "defaultPeriodHint": "Wählen Sie die Standard-Periode für die Erstellung neuer Flüge zwischen Morgen- oder Abendflügen",
      "morning": "Morgen",
      "evening": "Abend",
      "duplicateProtection": "Flugduplizierungsschutz",
      "duplicateProtectionHint": "Verhindert, dass ein Ballon für mehrere Fahrten gleichzeitig eingeplant wird. Sie können keine Passagiere zu einer Fahrt hinzufügen, wenn der gleiche Ballon zu dieser Zeit bereits eine andere aktive Fahrt hat.",
      "duplicateProtection_enabled": "schutz aktiviert",
      "duplicateProtection_disabled": "schutz deaktiviert"
    },
    "myflight": {
      "title": "Quick Release UP (Passengers App)",
      "autoConfirm": "bestätigt die Ballonfahrt automatisch, wenn er über UP angefordert wird",
      "autoConfirmHint": "Wenn dies nicht aktiviert wird, muss der Bediener die Ballonfahrt manuell bestätigen, wenn er über UP hinzugefügt wird",
      "autoConfirmEmailTemplate": "Bestätigungs-E-Mail-Vorlage",
      "autoConfirmEmailTemplateHint": "Wählen Sie eine E-Mail-Vorlage aus, die automatisch an den Passagier gesendet wird, wenn die Reservierung bestätigt wird",
      "noEmailTemplate": "Keine automatische E-Mail",
      "autoConfirmAPI": "bestätigt die Ballonfahrt automatisch, wenn sie über die API angefordert wird",
      "autoConfirmAPIHint": "wenn dies nicht aktiviert wird, muss der Betreiber die Ballonfahrt manuell bestätigen, wenn sie über die API hinzugefügt wird",
      "endOfSeason": "Saisonende",
      "endOfSeasonHint": "Wenn dies nicht aktiviert wird, können die Passagiere Fahrten für die gesamte Saison anfordern",
      "flights": "Welche Ballonfahrten können die Passagiere anfordern?",
      "ALL": "alle Ballonfahrten, unter Berücksichtigung der Tag-Einschränkungen",
      "REGIONAL": "nur regionale Ballonfahrten (Ballonfahrten, die in der Region des Passagier starten)",
      "NONE": "keine Ballonfahrten (Passagiere können keine Ballonfahrten anfordern)",
      "parameters": "Parameter",
      "branding": "Branding",
      "logo": "Logo",
      "logoHint": "Laden Sie ein Logo hoch, das in der UP-App angezeigt wird",
      "drag_and_drop_file_here": "Ziehen Sie Ihre .jpg- oder .png-Datei per Drag&Drop hierher (max. 500 kB)",
      "colors": "Farben",
      "colorsHint": "Klicken Sie auf jede Farbe, um sie an Ihren eigenen Stil anzupassen. Sie können eine Farbe aus der Palette Ihres Logos in dem Pop-up auswählen",
      "example": "Beispiel",
      "reset": "Farben zurücksetzen",
      "save": "Farben und Logo speichern",
      "primary_background_color": "Hintergrundfarbe der App",
      "secondary_background_color": "Hintergrundfarbe der Kacheln",
      "primary_foreground_color": "Textfarbe",
      "secondary_foreground_color": "Farbe des Informationstextes",
      "invalid_file_type_or_size": "Ungültiger Dateityp oder zu große Datei",
      "attachment_not_found": "Anhang nicht im Speicher gefunden — bitte entfernen und erneut hochladen",
      "translations": "Übersetzungen",
      "change_translations": "Einige Texte können angepasst werden",
      "click_button_to_change_translations": "Öffnen Sie den Login-Bildschirm der UP-App für Passagiere mit der Schaltfläche unten. Melden Sie sich mit einer Testreservierung oder einer Ihrer bestehenden Reservierungen an. Überall, wo das folgende Symbol erscheint, können Sie die Übersetzung anpassen.",
      "goto_api_settings": "Sie benötigen einen API-Schlüssel, um Übersetzungen ändern zu können. Gehen Sie zu den API-Einstellungen, um einen API-Schlüssel zu generieren.",
      "update_translations": "Übersetzungen aktualisieren"
    },
    "sms": {
      "footerEnabled": "footer zu SMS hinzufügen",
      "footerEnabledHint": "Wenn dies nicht aktiviert ist, wird die Fußzeile nicht allen Einladungs-SMS hinzugefügt"
    },
    "api": {
      "external_connection": "externe Verbindungen",
      "external_connection_subtitle": "verbinden Sie Ihre Website oder andere Apps mit Quick Release",
      "apiKey": "API-Schlüssel",
      "generateApiKey": "API-Schlüssel generieren",
      "noKeyMessage": "Sie haben noch keinen API-Schlüssel. Generieren Sie einen API-Schlüssel, um Zugang zur API zu erhalten.",
      "documentation": "Dokumentation",
      "documentationDescription": "Lesen Sie die Dokumentation für weitere Informationen über die API.",
      "apiPlayground": "API-Playground",
      "FlightAppDocumentation": "FlightApp Dokumentation",
      "FlightAppHint": "Verbinden Sie Quick Release mit den anerkannten digitalen Logbüchern von FlightApp. Die abgeschlossenen Fahrten werden automatisch an FlightApp übermittelt. Quick Release überprüft bei FlightApp die Gültigkeit von Ballonen und Piloten.",
      "FlightAppApikeyNotValid": "Fout: deze FlightApp API key is niet geldig",
      "FlightAppAircraftNotValid": "Diese FlightApp ballon wurde nicht gefunden in FlightApp. Bitte überprüfen Sie die Callsign.",
      "FlightAppPilotNotValid": "Diese FlightApp pilot wurde nicht gefunden in FlightApp. Bitte überprüfen Sie das Email.",
      "addFlightAppApiKey": "FlightApp API Key hinzufügen",
      "hideApiKey": "API Key ausblenden",
      "showApiKey": "API Key anzeigen",
      "copyToClipboard": "Kopieren",
      "newApiKey": "Neue API Key",
      "newApiKeyHint": "Neue API Key eingeben",
      "updating_keys": "die API-Schlüssel werden aktualisiert"
    },
    "callback": {
      "title": "Callback-URL",
      "subtitle": "Legen Sie eine Callback-URL fest, um Benachrichtigungen über Buchungsereignisse zu erhalten. Die JSON-Nutzlast enthält die bookingId, flightId und den neuen Buchungsstatus",
      "url": "Callback-URL",
      "noUrlMessage": "Es ist keine Callback-URL festgelegt. Klicken Sie unten auf die Schaltfläche, um eine festzulegen.",
      "setUrl": "Callback-URL festlegen",
      "saveUrl": "URL speichern",
      "clearUrl": "URL löschen"
    },
    "security": {
      "title": "Sicherheit",
      "twoFA": "Zwei-Faktor-Authentifizierung",
      "description": "Die Zwei-Faktor-Authentifizierung fügt Ihrem Konto eine zusätzliche Sicherheitsebene hinzu. Auf nicht vertrauenswürdigen Geräten müssen Sie einen zusätzlichen 6-stelligen Code eingeben, den Sie per E-Mail erhalten.",
      "enableTwoFA": "Zwei-Faktor-Authentifizierung aktivieren",
      "enableTwoFAConfirm": "Die Aktivierung der Zwei-Faktor-Authentifizierung wird Sie sofort abmelden. Sind Sie sicher?",
      "mandatory": "Zwei-Faktor-Authentifizierung ist ab dem 01. Januar 2026 obligatorisch"
    },
    "MESSAGING": {
      "ENABLED": "Nachrichten sind aktiviert",
      "ENABLED_HINT": "Nachrichten werden über WhatsApp gesendet. Wenn WhatsApp nicht verfügbar ist, kann SMS-Fallback verwendet werden.",
      "DISABLED": "Nachrichten sind deaktiviert",
      "DISABLED_HINT": "Kontaktieren Sie Quick Release, um Nachrichten für Ihr Konto zu aktivieren.",
      "STATUS_CONNECTED": "WhatsApp verbunden",
      "STATUS_DISCONNECTED": "WhatsApp nicht verbunden",
      "FALLBACK_WARNING": "WhatsApp ist nicht verfügbar. Nachricht wird per SMS gesendet (Kosten fallen an).",
      "RECONNECT_INSTRUCTIONS": "Bitte verbinden Sie Ihr WhatsApp-Gerät erneut, indem Sie den QR-Code unten scannen."
    },
    "checkin_title": "Online-Check-in",
    "checkin_mode_none": "kein Check-in",
    "checkin_mode_none_hint": "Check-in wird nicht verwendet.",
    "checkin_mode_pdf": "PDF-Check-in (manuell)",
    "checkin_mode_pdf_hint": "Drucken Sie das Check-in-Blatt mit Ihren Anweisungen; Passagiere unterschreiben am Fahrttag auf Papier.",
    "checkin_mode_online": "PDF + Online-Check-in",
    "checkin_mode_online_hint": "Passagiere checken vor der Fahrt online über die Buchungs-App ein; das PDF-Blatt bleibt verfügbar. Ein Benachrichtigungskanal (E-Mail oder WhatsApp) ist erforderlich.",
    "checkin_days_before": "Tage vor dem Flug",
    "checkin_notification_channel": "Check-in-Benachrichtigungskanal",
    "checkin_instructions": "Check-in-Anweisungen (Markdown)",
    "checkin_save_instructions": "Check-in-Anweisungen speichern",
    "checkin_load_default": "Standardanweisungen laden",
    "checkin_preview": "Vorschau",
    "checkin_schedule_explanation": "Wenn der Check-in aktiviert ist, können Passagiere {{days}} Tage vor ihrer Fahrt online über die Buchungs-App einchecken. Jeden Tag um 10:00 Uhr (belgische Zeit) wird automatisch eine Benachrichtigung an bestätigte Buchungen gesendet, deren Check-in-Fenster geöffnet ist.",
    "checkin_passenger_explanation": "Dieser Text wird beim Online-Check-in angezeigt (der Passagier muss bestätigen, ihn gelesen und verstanden zu haben) und wird auf dem PDF-Check-in-Blatt über den Unterschriften gedruckt. Nach dem Online-Check-in wird die Buchung in der App schreibgeschützt.",
    "checkin_channel_title": "Benachrichtigungskanal",
    "checkin_inapp_title": "Check-in-Text",
    "checkin_email_preview_title": "E-Mail-Benachrichtigung",
    "checkin_email_preview_subject": "Betreff",
    "checkin_whatsapp_preview_title": "WhatsApp-Benachrichtigung",
    "checkin_email_template_hint": "Diese Vorlage kann in Einstellungen → E-Mail-Vorlagen angepasst werden",
    "checkin_sms_template_hint": "Diese Vorlage kann in Einstellungen → SMS/WhatsApp-Vorlagen angepasst werden. Der Buchungslink wird automatisch als separate Nachricht gesendet."
  },
  "REPORTS": {
    "flights": "Ballonfahrten",
    "bookings_open": "Offene Buchungen",
    "bookings": "Neue Buchungen",
    "vouchers": "Voucher",
    "payments": "Zahlungen",
    "sms": "MSG"
  },
  "MAIL": {
    "hide": "Details ausblenden",
    "show": "Details anzeigen",
    "sent": "gesendet",
    "error": "Sendung fehlgeschlagen"
  },
  "TENANT_ACTIONS": {
    "WHATSAPP_PAIR_REQUIRED": "WhatsApp muss neu verbunden werden. Deine Nachrichten werden erst zugestellt, wenn du den neuen QR-Code gescannt hast.",
    "WHATSAPP_SESSION_DISCONNECTED": "Dein WhatsApp ist nicht verbunden. Verbinde dich erneut, um weiterhin Nachrichten zu senden.",
    "cta": "Jetzt neu verbinden",
    "dismiss": "Hinweis schließen"
  },
  "SUBSCRIPTION": {
    "WA_CLOUD": {
            "billable": "WhatsApp Business kostenpflichtig (Meta)",
            "free": "WhatsApp Business gratis",
            "info": "Richtwert — Meta berechnet WhatsApp-Business-Nachrichten direkt über Ihr eigenes Meta-Konto."
        },
    "sms_available": "im Abonnement erhältlich",
    "sms_sent": "SMS gesendet",
    "wa_sent": "WhatsApp gesendet",
    "recalculate": "neu berechnen",
    "pct_sms_used": "% Ihrer SMS wurden verwendet",
    "sms_info": "Kontaktieren Sie uns, um zusätzliche SMS zu bestellen, sobald Sie 95% der verfügbaren SMS in Ihrem Abonnement verwendet haben",
    "sms_warning": "Sie haben 95% oder mehr Ihrer verfügbaren SMS verwendet.",
    "LOW_SMS_BALANCE": "Niedriges SMS-Guthaben - SMS-Fallback kann fehlschlagen, wenn WhatsApp nicht verfügbar ist.",
    "order_sms": "Jetzt neue SMS bestellen",
    "sms_ignore_warning": "Benachrichtigung über SMS-Nutzung ausblenden",
    "pct_plan_used": "% Ihrer Sitzplätze sind belegt",
    "plan_seats_used": "Gesamtballonkapazität",
    "plan_valid_until": "gültig bis",
    "plan_info": "Kontaktieren Sie uns, um zu einem höheren Tarif zu wechseln, wenn die Anzahl der Lizenzen zu niedrig ist, oder um Ihr aktuelles Abonnement zu verlängern",
    "plan_expiring": "Ihr Abonnement läuft bald ab. Bitte verlängern Sie es, um Unterbrechungen zu vermeiden.",
    "plan_expiring_days": "Ihr Abonnement läuft in {days} Tagen ab. Bitte verlängern Sie es, um Unterbrechungen zu vermeiden.",
    "plan_expired_grace_days": "Ihr Abonnement ist abgelaufen. Nachfrist endet in {days} Tagen. Bitte verlängern Sie sofort.",
    "plan_expired_since_days": "Ihr Abonnement ist vor {days} Tagen abgelaufen. Bitte verlängern Sie, um Quick Release weiter zu nutzen.",
    "plan_expired": "Ihr Abonnement ist abgelaufen und die Nachfrist ist beendet. Bitte verlängern Sie, um Quick Release weiter zu nutzen.",
    "plan_invalid_grace_days": "Ihr Abonnement ist nicht gültig - Sie haben Ihre Kapazität überschritten. Nachfrist endet in {days} Tagen. Bitte verlängern Sie sofort.",
    "plan_invalid_expired": "Ihr Abonnement ist nicht gültig - Sie haben Ihre Kapazität überschritten. Nachfrist ist beendet. Bitte verlängern Sie sofort, um Quick Release weiter zu nutzen.",
    "manage_subscription": "Abonnement verwalten",
    "EXPIRED_MESSAGE": "Abonnement abgelaufen. Erneuern Sie es, um fortzufahren.",
    "blocked": "Abonnement abgelaufen. Bitte erneuern Sie es, um fortzufahren.",
    "custom_plan_title": "Benutzerdefinierter Abonnementplan",
    "custom_plan_subtitle": "Manuelle Verlängerung erforderlich",
    "custom_plan_message": "Sie haben einen benutzerdefinierten Abonnementplan.",
    "custom_plan_contact": "Bitte kontaktieren Sie das Quick Release-Team um eine Anpassung oder Verlängerung anzufordern."
  },
  "TAGS": {
    "delete": "tag entfernen",
    "enabled": "aktiviert",
    "enable_tag": "Tag aktivieren",
    "disabled": "deaktiviert",
    "disable_tag": "Tag deaktivieren",
    "save": "tag speichern",
    "new_tag": "neues Tag erstellen",
    "tag_name": "tag-Name",
    "tag_type": "tag-Typ",
    "select_tag_color": "Wähle Farbe",
    "color": "Farbe",
    "tag_already_added": "Tag bereits hinzugefügt",
    "edit": "Tag bearbeiten",
    "flight_tags": "Fahrt-Tags",
    "tags": "tags",
    "show_on_dashboard": "auf dem Dashboard anzeigen",
    "allowedFlightTags": "erlaubte",
    "not_restricted": "Alle Buchungen erlaubt",
    "all_flights_allowed": "alle Fahrten erlaubt, es sei denn, spezifische Buchungstags sind erforderlich",
    "onlyAllowedFlightTags": "nur diese Buchungstags sind erlaubt",
    "no_bookings_allowed": "keine Buchungen erlaubt"
  },
  "LOGBOOK": {
    "no_logbook_found": "geen logboek gevonden",
    "new_logs_since": "Neue Logs seit",
    "new_logs_since_beginning": "Neue Logs seit Anfang",
    "total_new_logs": "Anzahl neuer Logs:",
    "total_flight_time": "Gesamte Flugzeit:",
    "add": "Hinzufügen",
    "log": "log",
    "logs": "logs",
    "refresh": "Aktualisieren",
    "logs_in_logbook": "Logs im Logbuch",
    "total_logs": "Anzahl Logs:",
    "latest_log": "Letzter Log:",
    "export": "Exportieren",
    "send_to_flightapp": "An FlightApp senden",
    "delete_log": "Log löschen",
    "confirm_delete_log": "Diesen Logeintrag löschen?",
    "confirm_delete_log_body": "Dadurch wird der Logeintrag aus dem Logbuch entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    "start_date": "Startdatum",
    "initial_hours": "Flugzeit vor dem digitalen Logbuch",
    "initial_hours_hint": "Stunden aus dem Papierlogbuch",
    "total_logged_time": "Erfasste Flugzeit",
    "total_overall_time": "Gesamte Flugzeit",
    "settings": "Logbuch-Einstellungen",
    "setup_logbook": "Logbuch einrichten",
    "start_date_hint": "Beginn des digitalen Logbuchs. Flüge vor diesem Datum gehören zum Papierlogbuch – tragen Sie deren Summen unten ein; Flüge ab diesem Datum werden aus Quick Release gezählt. Ältere digitale Flüge bleiben ausgegraut sichtbar.",
    "before_start_date": "Vor dem Startdatum – Papier-Ära, nicht in den Summen gezählt",
    "hours": "Stunden",
    "minutes": "Minuten",
    "save_settings": "Speichern",
    "settings_saved": "Logbuch-Einstellungen gespeichert",
    "initial_flights": "Flüge vor dem Logbuch",
    "initial_flights_short": "vorher",
    "total_flights": "Flüge gesamt",
    "flights": "Flüge",
    "logged_short": "erfasst",
    "stats_since": "Statistik seit",
    "logbook_title": "Logbuch",
    "up_to_date": "Aktuell",
    "pending_short": "hinzufügen",
    "from_system_pending": "aus dem System, noch nicht hinzugefügt",
    "logged_flights": "Erfasste Flüge"
  },
  "IMAGES": {
    "images": "Bilder",
    "upload_new_images": "Neue Bilder hochladen",
    "drag_and_drop_images_here": "Bilder hierher ziehen und ablegen",
    "max_files_reached": "Maximale Anzahl von Bilder erreicht",
    "browse_for_images": "Bilder durchsuchen",
    "supported_formats": "Unterstützte Formate",
    "max_size_5mb": "max. Größe 5MB",
    "uploading": "Hochladen",
    "image_library": "Bilderbibliothek",
    "no_images_found": "Keine Bilder gefunden",
    "delete_image": "Bild löschen",
    "hint": "Die hochgeladenen Bilder können beim Versenden von WhatsApp-Nachrichten verwendet werden"
  },
  "INVOICE": {
    "LOADING": "Rechnungen werden geladen...",
    "EMPTY_STATE": "Keine Rechnungen der letzten 4 Jahre gefunden",
    "TABLE": {
      "TITLE": "Rechnungen",
      "SUBTITLE": "Übersicht Ihrer Rechnungen",
      "INFO": "Hier finden Sie alle Ihre Rechnungen der letzten 4 Jahre. Klicken Sie auf das Download-Symbol, um eine Rechnung herunterzuladen.",
      "INVOICE_CODE": "Rechnungsnummer",
      "AMOUNT": "Betrag",
      "DATE": "Datum",
      "STATUS": "Status",
      "ACTIONS": "Aktionen",
      "DOWNLOAD_TOOLTIP": "Rechnung herunterladen"
    },
    "STATUS": {
      "PAID": "Bezahlt",
      "SENT": "Gesendet",
      "REMINDED": "Erinnert",
      "SUMMATION": "Mahnung",
      "EXPIRED": "Abgelaufen",
      "DRAFT": "Entwurf"
    }
  },
  "ORDER": {
    "LOADING": "Bestellungen werden geladen...",
    "EMPTY_STATE": "Keine Bestellungen der letzten 4 Jahre gefunden",
    "TABLE": {
      "TITLE": "Bestellungen",
      "SUBTITLE": "Übersicht Ihrer Bestellungen",
      "INFO_PENDING": "Sie können Artikel zu einer ausstehenden Bestellung hinzufügen oder diese vollständig löschen.",
      "INFO_CONFIRMED_TITLE": "Nach Bestätigung:",
      "INFO_CONFIRMED_1": "Sie erhalten eine Bestellbestätigung per E-Mail",
      "INFO_CONFIRMED_2": "Ihre Bestellung wird bearbeitet und genehmigt",
      "INFO_CONFIRMED_3": "Sie erhalten die Rechnung per E-Mail",
      "INFO_CONFIRMED_4": "Der neue Plan oder die Credits werden aktiviert",
      "AMOUNT": "Betrag",
      "DATE": "Datum",
      "STATUS": "Status",
      "ITEMS": "Artikel",
      "PLAN": "Plan"
    },
    "STATUS": {
      "PENDING": "Ausstehend",
      "CONFIRMED": "In Bearbeitung",
      "APPROVED": "Genehmigt",
      "CANCELLED": "Storniert"
    },
    "ACTIONS": {
      "CONFIRM": "Bestätigen",
      "DELETE": "Löschen",
      "APPROVE": "Genehmigen",
      "CANCEL": "Stornieren"
    }
  },
  "DEBTOR_VALIDATION": {
    "TITLE": "Rechnungskonfiguration erforderlich",
    "SUBTITLE": "Ihre Schuldnerdaten müssen konfiguriert werden",
    "MESSAGE": "Bitte kontaktieren Sie das Quick Release Team, um Ihre Rechnungsdaten zu konfigurieren und die automatische Verlängerung und das Upgrade zu ermöglichen."
  },
  "NEW_ORDER": {
    "TITLE": "Neue Bestellung",
    "SUBTITLE": "Artikel zu Ihrer Bestellung hinzufügen",
    "INFO_SMS": "Bestellen Sie zusätzliches Guthaben: 1 oder mehrere Pakete von 100 SMS oder 1000 SMS.",
    "INFO_PLAN": "Automatisch berechnet basierend auf Ihrem Abonnementstatus und Ihrer Ballonkapazität. Bei einem Upgrade zahlen Sie nur die Differenz.",
    "SUBTITLE_PLAN": "Automatisch berechnet basierend auf Ihrem Abonnementstatus und Ihrer Ballonkapazität. Bei einem Upgrade zahlen Sie nur die Differenz.",
    "SUBTITLE_SMS": "Bestellen Sie zusätzliches Guthaben: 1 oder mehrere Pakete von 100 SMS oder 1000 SMS.",
    "PLAN": {
      "TITLE": "Plan-Verlängerung/Upgrade",
      "EMPTY_MESSAGE": "Keine Pläne verfügbar",
      "NAME": "Plan",
      "MAX_SEATS": "Maximale Sitzplätze"
    },
    "UNIT_PRICE": "Stückpreis",
    "QUANTITY": "Menge",
    "ORDER_QUANTITY": "Menge",
    "TOTAL": "Gesamt",
    "CREDIT_AUTO_ADDED": "Guthaben automatisch angewendet",
    "ALREADY_IN_ORDER": "Bereits in Bestellung",
    "ADD_TO_ORDER": "Zur Bestellung hinzufügen",
    "SMS": {
      "TITLE": "SMS",
      "UNIT_PRICE": "Preis pro Paket",
      "PER_PACKAGE": "Pro Paket",
      "ORDER_QUANTITY": "Anzahl der Pakete",
      "TOTAL_SMS": "Gesamt SMS"
    },
    "SUCCESS": "Artikel zur Bestellung hinzugefügt",
    "ERROR_LINE": "Fehler beim Hinzufügen der Bestellzeile",
    "ERROR_ORDER": "Fehler beim Erstellen der Bestellung",
    "SUBMITTING": "Bestellungen aufgeben...",
    "CONFIRM_DIALOG": {
      "TITLE": "Bestellung bestätigen",
      "MESSAGE": "Sie sind dabei, eine Bestellung aufzugeben.",
      "ORDER": "Bestellung",
      "TOTAL": "Gesamt",
      "VAT_EXCL": "MwSt. ausgen.",
      "VAT_21": "MwSt. 21%",
      "TOTAL_WITH_VAT": "Gesamt inkl. MwSt.",
      "VAT_REVERSE_CHARGE_NOTE": "Hinweis: Reverse Charge (Verlagerung der MwSt.) kann auf Ihre Bestellung angewendet werden.",
      "VAT_REVERSE_CHARGE_SHORT": "(Reverse Charge kann anwendbar sein)",
      "NO_PAYMENT_OBLIGATION": "Nach Genehmigung Ihrer Bestellung erhalten Sie eine Rechnung mit Zahlungsverpflichtung.",
      "AGREE_TERMS": "Ich stimme den",
      "TERMS_LINK": "Allgemeinen Geschäftsbedingungen zu",
      "CONFIRM_ORDER": "Bestellung bestätigen"
    }
  },
  "CHECKIN": {
    "not_all_checked_in": "Nicht alle Passagiere haben online eingecheckt",
    "proceed_warning": "{{count}} von {{total}} bestätigten Buchungen haben den Online-Check-in nicht abgeschlossen. Möchten Sie fortfahren?",
    "opens_on": "Check-in öffnet am {{date}}",
    "checked_in": "eingecheckt",
    "checkin_open": "Check-in geöffnet",
    "invite_sent_at": "Check-in-Einladung gesendet am {{date}}",
    "invite_not_sent": "noch keine Check-in-Einladung gesendet",
    "send_invite": "Check-in-Einladung senden",
    "invite_sent_success": "Check-in-Einladung gesendet",
    "send_invite_all": "Check-in-Einladung an alle offenen Buchungen senden",
    "send_invite_all_confirm": "Check-in-Einladung an {{count}} Buchungen senden?",
    "invites_status_sent": "{{count}} Einladung(en) gesendet",
    "invites_status_planned": "{{count}} geplant für {{date}}",
    "invite_planned_on": "Check-in-Einladung geplant für {{date}}",
    "send_now": "jetzt senden",
    "preview_subject": "Ihre Fahrt ist bereit für den Check-in – {{date}} – {{location}}",
    "preview_greeting": "Liebe(r) {{name}},",
    "preview_body": "Ihre Ballonfahrt am <strong>{{date}}</strong> ist jetzt für den Online-Check-in geöffnet.",
    "preview_body2": "Bitte schließen Sie den Check-in für Ihre Gruppe ({{count}} Passagiere) vor dem Fahrtdatum ab. Beim Check-in werden Sie gebeten, die Sicherheitshinweise zu lesen und zu bestätigen.",
    "preview_cta": "Jetzt einchecken",
    "preview_footer": "Bei Fragen kontaktieren Sie uns bitte.",
    "preview_wa_body": "Ihre Ballonfahrt am **{{date}}** ist jetzt für den Online-Check-in geöffnet.",
    "preview_wa_body2": "Bitte schließen Sie den Check-in für Ihre Gruppe ({{count}} Passagiere) vor dem Fahrtdatum ab.",
    "preview_wa_link": "Mit diesem Link geht es direkt zu deiner persönlichen Buchungsseite!",
    "signature_sheet": "Check-in-Unterschriftenliste",
    "acknowledge": "Ich habe die oben stehenden Informationen gelesen und verstanden",
    "pdf_check_in": "CHECK-IN",
    "pdf_passenger_manifest": "Passagierliste",
    "pdf_safety_briefing": "Sicherheitseinweisung",
    "pdf_please_read": "Bitte vor dem Einsteigen lesen",
    "pdf_balloon_operator": "Heißluftballonbetreiber",
    "pdf_acknowledgement": "BESTÄTIGUNG",
    "pdf_passenger": "Passagier",
    "pdf_signature": "Unterschrift",
    "pdf_morning_flight": "Morgenfahrt",
    "pdf_evening_flight": "Abendfahrt",
    "pdf_date": "DATUM",
    "pdf_balloon": "BALLON",
    "pdf_pic": "VERANTWORTLICHER PILOT",
    "pdf_takeoff": "ABFAHRT",
    "pdf_pic_on_file": "PIC-Unterschrift vorhanden",
    "pdf_local_time": "Ortszeit",
    "pdf_page": "Seite {{current}} von {{total}}",
    "pdf_manifest_subtitle": "{{pax}} Passagiere · {{bookings}} Buchungen"
  },
  "NOTAM": {
    "title": "NOTAMs",
    "panel_title_combined": "Wetter und NOTAM",
    "tooltip_count": "{{count}} NOTAM(s) — Flug für Details öffnen",
    "none_known": "keine relevanten NOTAMs bekannt",
    "none_known_short": "keine NOTAMs bekannt",
    "no_data": "keine NOTAM-Daten für diesen Startplatz",
    "stale": "NOTAM-Daten konnten nicht aktualisiert werden — letzte Aktualisierung {{time}}",
    "unavailable": "NOTAM-Daten nicht verfügbar",
    "retry": "erneut versuchen",
    "updated": "NOTAM-Daten aktualisiert {{time}}",
    "disclaimer": "Nur zur Entscheidungsunterstützung — die offizielle Briefingpflicht vor dem Flug verbleibt beim verantwortlichen Piloten (PIC).",
    "horizon_hint": "NOTAMs werden meist erst kurz vor dem Datum veröffentlicht, kurz vor der Fahrt erneut prüfen",
    "wide_area": "Hintergrundhinweise (großflächig / AIP)",
    "show_text": "NOTAM-Originaltext anzeigen",
    "hide_text": "NOTAM-Originaltext ausblenden",
    "period": "aktiver Zeitraum",
    "schedule": "Tageszeitplan",
    "altitude_band": "Höhenband",
    "connect_hint": "verbinde dein Autorouter-Konto, um NOTAM-Warnungen zu sehen",
    "reconnect_hint": "verbinde dein Autorouter-Konto erneut, um NOTAM-Warnungen zu aktualisieren",
    "connect_link": "Einstellungen öffnen",
    "location_warning": "{{count}} NOTAM(s) an diesem Startplatz für das Zeitfenster der Fahrt",
    "CATEGORY": {
      "RESTRICTION": "Luftraumbeschränkung",
      "WARNING": "Navigationswarnung",
      "OBSTACLE": "Hindernis",
      "AERODROME": "Flugplatz",
      "UNCLASSIFIED": "nicht klassifiziert"
    },
    "SETTINGS": {
      "title": "Luftraum / NOTAM",
      "explanation": "NOTAM-Warnungen auf Fahrten, der Trajektorienkarte und dem Dashboard erfordern ein eigenes (kostenloses) autorouter.aero-Konto. Quick Release ruft NOTAM-Daten unter der Autorisierung deines Kontos ab.",
      "disclaimer": "NOTAM-Warnungen dienen nur der Entscheidungsunterstützung; die offizielle Briefingpflicht vor dem Flug verbleibt beim verantwortlichen Piloten (PIC).",
      "connect": "Autorouter-Konto verbinden",
      "reconnect": "Autorouter-Konto erneut verbinden",
      "disconnect": "trennen",
      "disconnect_confirm": "Autorouter-Konto trennen? Die gespeicherte Autorisierung und die abgerufenen NOTAM-Daten werden entfernt.",
      "connected_as": "verbunden als",
      "connected_since": "seit",
      "status_disconnected": "kein Autorouter-Konto verbunden",
      "reauth_warning": "die Autorouter-Autorisierung ist abgelaufen oder wurde widerrufen — erneut verbinden, um weiterhin NOTAM-Daten zu erhalten",
      "connected_snack": "Autorouter-Konto verbunden",
      "denied_snack": "Autorouter-Verbindung abgelehnt",
      "error_snack": "Autorouter-Verbindung fehlgeschlagen — bitte erneut versuchen"
    }
  },
  "WEEKPLANNER": {
    "matrix": {
      "availability": "Verfügbarkeit",
      "availability_tooltip": "Anzahl verfügbarer Piloten und Crew — Punkte überfahren für Namen",
      "availability_empty": "Noch keine Verfügbarkeitsverwaltung. Lass Piloten und Crew ihre Verfügbarkeit selbst eintragen, dann siehst du hier pro Tag, wer fahren kann.",
      "start_crew_login": "Mit Crew-Login starten",
      "pilots_available": "verfügbare Piloten",
      "crew_available": "verfügbare Crew",
      "open_balloon": "Ballondetail öffnen",
      "seats": "Plätze",
      "add_balloon": "Ballon hinzufügen",
      "no_balloons": "Noch keine Ballone. Füge deinen ersten Ballon hinzu, um Fahrten zu planen.",
      "no_flights": "Keine Fahrten diese Woche.",
      "show_idle_balloons": "Ballone ohne Fahrt ({{count}})",
      "hide_idle_balloons": "Ballone ohne Fahrt ausblenden",
      "add_flight_for": "Fahrt hinzufügen —",
      "open_flight_tooltip": "Fahrtdetail öffnen (oder Strg/Cmd-Klick auf die Zelle)",
      "fly_ok": "Fahrbar",
      "fly_wind": "Windwarnung",
      "fly_rain": "Nicht fahrbar — Niederschlag",
      "fly_nogo_wind": "Nicht fahrbar — Wind"
    },
    "availability": {
      "yes": "verfügbar",
      "maybe": "vielleicht",
      "no": "nicht verfügbar",
      "unknown": "nicht ausgefüllt"
    },
    "create": {
      "new_location_option": "+ Neuer Startplatz…",
      "no_locations": "Du hast noch keine Startplätze. Lege den ersten an.",
      "new_location": "Neuer Startplatz",
      "new_location_placeholder": "z. B. Brügge – Minnewater",
      "new_location_note": "GPS, Genehmigung und Kontakt ergänzt du später im Startplatzdetail.",
      "save_location": "Startplatz speichern",
      "location_created": "Startplatz {{name}} angelegt.",
      "location_created_default": "Startplatz {{name}} angelegt — auch dein Standard-Startplatz für Wetter und Sonne."
    },
    "planner": {
      "available_drag": "verfügbar — auf eine Fahrt ziehen",
      "no_people": "noch keine Piloten oder Crew",
      "assign_to": "Zuweisen an…",
      "add_pilot": "Pilot",
      "add_crew": "Crew",
      "edit": "Fahrtinfo bearbeiten",
      "edit_done": "Bearbeitung fertig",
      "publish": "Für Crew veröffentlichen",
      "unpublish": "Vor Crew verbergen",
      "mark_finished": "Als durchgeführt markieren",
      "cancel": "Fahrt absagen",
      "restore": "Fahrt wiederherstellen",
      "staffing": "Pilot, BE-Fahrer und Crew",
      "published_chip": "Crew",
      "published_tooltip": "Für die Crew sichtbar",
      "pilot": "Pilot",
      "driver": "BE-Fahrer",
      "crew": "Crew",
      "takeoff_temperature": "Temperatur beim Start",
      "trajectory": "Route",
      "lift_free": "{{kg}} kg frei",
      "capacity_warning_title": "Das überschreitet die Ballonkapazität",
      "capacity_warning_body": "{{total}} Passagiere auf {{capacity}} Plätzen. Trotzdem fortfahren?",
      "lift_warning_title": "Wenig Auftrieb auf dieser Fahrt",
      "lift_warning_body": "Nur noch {{lift}} kg Auftrieb frei. Trotzdem zuweisen?",
      "person_already_assigned": "{{name}} ist in diesem Tagesteil schon auf {{flight}}.",
      "cancel_on_flight_page": "Diese Fahrt hat bestätigte Buchungen: sage sie auf der Fahrtseite ab, damit die Passagiere informiert werden.",
      "preferred_of": "Stammcrew von {{balloons}}",
      "propose_crew": "Stammcrew vorschlagen",
      "propose_tooltip": "{{names}} auf die Fahrt von {{balloon}} setzen",
      "apply_all": "Alle übernehmen"
    },
    "toast": {
      "flight_updated": "Fahrt aktualisiert — Wochendaten neu geladen.",
      "booking_confirmed": "Buchung bestätigt — Bestätigungsmail versendet.",
      "balloon_updated": "Ballon aktualisiert.",
      "save_failed": "Speichern fehlgeschlagen — bitte erneut versuchen."
    },
    "pool": {
      "oldest_first": "älteste zuerst",
      "clear_search": "löschen",
      "new_booking": "Neue Buchung",
      "filters": "Filter",
      "count_tooltip": "Anzahl innerhalb der aktuellen Suche",
      "chip_to_confirm": "zu bestätigen",
      "chip_unplanned": "nicht eingeplant",
      "chip_voucher": "Gutschein läuft ab",
      "chip_open_amount": "offener Betrag",
      "chip_favourite": "Favorit",
      "clear_filters": "Filter löschen",
      "col_name": "Name",
      "col_contact": "Kontakt",
      "col_pax": "Pers. · Gewicht",
      "col_info": "Info",
      "col_comment": "Bemerkung",
      "col_flight": "Fahrt",
      "col_actions": "Aktionen",
      "no_match": "Keine Buchungen für diese Filter.",
      "flight_tooltip": "Fahrt öffnen — Ziehen verschiebt die Buchung",
      "unplanned": "nicht eingeplant",
      "confirm": "Bestätigen",
      "load_more_n": "Mehr laden ({{n}})"
    },
    "panel": {
      "kind_flight": "Fahrt",
      "kind_balloon": "Ballon",
      "kind_booking": "Buchung",
      "kind_person": "Person",
      "kind_location": "Startplatz",
      "back": "Zurück zum Wochenplaner",
      "close": "Schließen",
      "not_found": "Nicht gefunden — vielleicht gelöscht.",
      "balloon": "Ballon",
      "status": "Status",
      "status_SCH": "geplant",
      "status_REA": "bereit zum Start",
      "status_FIN": "durchgeführt",
      "status_CAN": "abgesagt",
      "sun": "Sonne",
      "sunrise": "Sonnenaufgang",
      "sunset": "Sonnenuntergang",
      "yes": "ja",
      "no": "nein",
      "crew_section": "Besatzung",
      "bookings": "Buchungen",
      "no_bookings_on_flight": "Noch keine Buchungen auf dieser Fahrt.",
      "heading": "Erwartete Richtung",
      "distance": "Distanz",
      "landing_zone": "Landezone",
      "logbook": "Logbuch",
      "takeoff_time": "Startzeit",
      "landing_time": "Landezeit",
      "landing_place": "Landeplatz",
      "fuel": "Verbrauch (Flaschen)",
      "open_page": "Ganze Seite öffnen",
      "passenger_seats": "Passagierplätze",
      "passenger_seats_label": "Passagierplätze",
      "basics": "Basis",
      "registration": "Kennzeichen",
      "to_complete": "noch zu ergänzen",
      "envelope": "Hülle",
      "envelope_manufacturer": "Hersteller",
      "envelope_volume": "Volumen (m³)",
      "envelope_type": "Typ",
      "basket_burner": "Korb & Brenner",
      "basket_type": "Korbtyp",
      "burner_type": "Brenner",
      "cylinders": "Anzahl Flaschen",
      "insurance": "Versicherung",
      "insurance_company": "Gesellschaft",
      "due_date": "Ablaufdatum",
      "maintenance": "Wartung",
      "last_inspection": "Letzte Inspektion",
      "envelope_hours": "Fahrstunden Hülle",
      "flights_this_week": "Fahrten diese Woche",
      "no_flights": "Keine Fahrten geplant.",
      "booking_detail": "Buchungsdetail",
      "contact": "Kontakt",
      "phone": "Telefon",
      "email": "E-Mail",
      "city": "Ort",
      "passengers": "Passagiere",
      "preferred": "Gewünscht",
      "not_chosen": "noch nicht gewählt",
      "not_planned": "Nicht eingeplant.",
      "booking_status_OPEN": "offen",
      "booking_status_ADDE": "hinzugefügt — zu bestätigen",
      "booking_status_INVI": "eingeladen",
      "booking_status_CONF": "bestätigt",
      "booking_status_COMP": "abgeschlossen",
      "booking_status_CANC": "storniert",
      "region": "Region",
      "payment": "Zahlung",
      "to_pay": "Zu zahlen",
      "paid": "Bezahlt",
      "voucher": "Gutschein",
      "booking_code": "Code",
      "valid_until": "Gültig bis",
      "passenger_n": "Passagier {{n}}",
      "open_flight": "Fahrt öffnen",
      "availability_this_week": "Verfügbarkeit diese Woche",
      "profile": "Profil",
      "license_number": "Lizenznummer",
      "license_expiry": "Lizenz gültig bis",
      "medical_until": "Medical bis",
      "driver_licence_be": "Führerschein BE",
      "launch_site": "Startplatz",
      "default_for_weather": "Standard-Startplatz für Wetter und Sonne",
      "default_location": "Standard-Startplatz",
      "no_flights_location": "Keine Fahrten von diesem Startplatz.",
      "location_detail": "Startplatzdetail",
      "gps": "GPS-Koordinaten",
      "address": "Adresse",
      "contact_person": "Kontaktperson",
      "access_parking": "Zufahrt & Parken",
      "preferred_crew": "Stammcrew",
      "preferred_crew_note": "Basierend auf früheren Zuweisungen.",
      "preferred_crew_of": "Stammcrew von",
      "no_preferred_balloon": "Noch kein Stammballon — ergibt sich aus den Zuweisungen."
    },
    "meteo": {
      "title": "Wetter",
      "no_default_location": "kein Standard-Startplatz",
      "follows_selection": "folgt dem gewählten Tag",
      "today_hint": "heute — wähle einen Tag in der Matrix",
      "sun": "Sonne {{rise}} – {{set}}",
      "pill_good": "fahrbar",
      "pill_marginal": "fraglich",
      "pill_nogo": "nicht fahrbar",
      "pill_unknown": "keine Vorhersage",
      "pill_tooltip_good": "Fahrbar — Wind innerhalb der Grenzen",
      "pill_tooltip_marginal": "Fraglich — Böen über dem Grenzwert",
      "pill_tooltip_nogo": "Nicht fahrbar — Niederschlag oder Wind über den Grenzen",
      "pill_tooltip_unknown": "Keine Vorhersage für diesen Tagesteil",
      "no_forecast": "keine Vorhersage für diesen Tag",
      "row_hour": "Stunde",
      "row_weather": "Wetter",
      "row_temp": "Temp (°C)",
      "row_ground": "Boden",
      "row_wind": "Wind (kn)",
      "row_gust": "Böen (kn)",
      "row_pressure": "Druck (hPa)",
      "row_clouds": "Bewölkung",
      "row_visibility": "Sicht (km)",
      "legend": "goldene Stunden — Fahrtfenster um Sonnenaufgang ({{rise}}) und Sonnenuntergang ({{set}}) · Fiedern: volle = 10 kn, halbe = 5 kn",
      "updated": "aktualisiert"
    },
    "myWeek": {
      "title": "Meine Woche — {{name}}",
      "hint": "Verfügbarkeit: klicken zum Wechseln · über Tage ziehen zum Kopieren",
      "my_availability": "meine Verfügbarkeit",
      "flights": "Fahrten",
      "click_to_fill": "zum Ausfüllen klicken",
      "own_pilot": "Meine Fahrt — ich fahre",
      "own_crew": "Meine Fahrt — ich fahre mit",
      "published": "Veröffentlichte Fahrt",
      "join": "Ich komme mit",
      "saved": "Verfügbarkeit gespeichert — der Planer sieht es sofort.",
      "cleared": "Verfügbarkeit gelöscht.",
      "error_FLIGHT_HAS_CREW": "Jemand anderes fährt schon mit.",
      "error_FLIGHT_NOT_PUBLISHED": "Diese Fahrt ist nicht mehr veröffentlicht.",
      "error_FLIGHT_NOT_SCHEDULED": "Diese Fahrt ist nicht mehr geplant.",
      "error_NOT_ON_FLIGHT": "Du bist nicht mehr auf dieser Fahrt.",
      "error_ALREADY_PILOT": "Du bist schon Pilot dieser Fahrt."
    },
    "theme": {
      "title": "Design",
      "light": "Hell",
      "dark": "Dunkel",
      "system": "System"
    }
  }
}
